var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 22,
    viewBox: "0 0 36 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "i31x10s1ta",
    d: "M0.059 0.131L2.597 0.131 2.597 3.578 0.059 3.578z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "yb0ibnm2wc",
    d: "M0 0.024L2.995 0.024 2.995 0.772 0 0.772z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u2iz6nfu3e",
    d: "M0.142 0.116L0.374 0.116 0.374 0.719 0.142 0.719z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7x0z1bb4gg",
    d: "M0.127 0.093L0.374 0.093 0.374 1.21 0.127 1.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "yjh71tw4mi",
    d: "M0.207 0.219L0.374 0.219 0.374 0.469 0.207 0.469z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j8lf3q5lhk",
    d: "M0.25 0.197L0.492 0.197 0.492 0.447 0.25 0.447z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "20snskh42m",
    d: "M0.186 0.191L0.374 0.191 0.374 0.441 0.186 0.441z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-188 -58) translate(188 58)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5,
    height: 21.5,
    x: 0.25,
    y: 0.25,
    fill: "#FFF",
    stroke: "#C7C7C7",
    strokeWidth: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M7.505 1.974L7.503 2c.008.012.01.023.007.036-.04.112-.077.225-.119.337-.053.139-.102.28-.182.406l.002-.002c-.036.14-.058.284-.155.4-.153.064-.09-.088-.153-.153-.011.157.052.297.01.434-.01.011-.021.02-.034.025-.226.029-.454-.002-.68.018-.013.003-.028.004-.042.002-.065-.017-.073-.074-.09-.126-.041-.12-.095-.234-.143-.35-.021-.06-.045-.118-.052-.182.015-.065-.026-.124-.024-.188 0-.001-.008-.004-.012-.004s-.007.004-.012.006c-.034-.007-.022-.043-.039-.062v.001c-.036-.098-.104-.184-.118-.291-.012-.039.024-.09-.031-.117-.022-.012-.025-.033-.026-.055.001-.024.01-.05-.016-.067-.008-.005-.014-.013-.016-.023l-.162-.46c0-.057-.002-.112-.055-.148l-.024-.033c-.04-.027-.026-.096-.085-.108-.023-.024-.04-.059-.084-.04-.036.016-.035.05-.03.078.008.044-.037.115.055.122.008.01.014.022.018.034.015.092-.013.18-.024.27-.008.07-.059.091-.123.085C5 1.84 4.976 1.8 4.976 1.738c0-.052-.003-.103.025-.15.037-.064.038-.132.025-.202.01.074.007.145-.031.212-.03.052-.021.11-.018.165.023.467.005.934.01 1.4 0 .17-.009.177-.173.177H4.66c.087-.005.204.015.318-.012.053-.013.09.087.144.014.015-.004.03-.004.044 0 .048.025.106.046.056.118-.076.043-.16.024-.24.022-.174-.005-.35.022-.525-.016-.005-.207-.02-.414-.015-.621V.584c0-.048-.004-.095.005-.143.041-.04.095-.04.146-.041.376-.001.752-.002 1 0-.283.007-.694-.015-1.105.008-.023.001-.042-.01-.06-.023.011-.033.04-.026.065-.026L5.8.362c.044.045.068.1.074.163-.003.046-.017.096.041.12.044.1.08.203.115.306-.026.084.051.154.032.24-.002.008.026-.022.045-.01.07.065.064.162.103.24.01.064.06.112.069.176.007.046.002.097.045.131.034.078.067.157.094.238.02.065.048.127.063.192.029.025.017.089.07.087.033-.001.018-.052.043-.068.065-.008.04-.062.05-.098.1-.3.211-.598.333-.89.063-.05.07-.13.095-.198.044-.114.094-.226.128-.344.059-.079.077-.176.112-.265.018-.045.042-.03.069-.035h1.17c.069-.001.11.006.11.096-.004 1.013-.001 2.026-.003 3.039 0 .008-.003.017-.005.025-.071.074-.157.012-.235.02-.187.016-.377.02-.566-.003-.016-.01-.022-.023-.017-.041.17-.026.34-.006.51-.012.08-.002.16-.007.227-.061.019-.055.01-.112.01-.168.001-.812.003-1.625-.001-2.438C8.58.702 8.638.601 8.589.5c-.005.026.02.04.018.061 0 .026.003.052-.017.074-.047.035-.034.086-.034.132-.001.815-.002 1.63 0 2.445 0 .189-.015.195-.19.138-.106-.035-.223-.002-.295-.01.041.003.122-.002.202.001.083.003.143.037.16.126-.197.007-.394.002-.59.002-.1-.041-.052-.13-.066-.2.004-.444-.006-.888.005-1.332.02-.19-.011-.379-.006-.568-.006-.018.01-.036-.001-.059-.01.03-.006.06-.018.086-.09.165-.132.348-.205.52-.01.025-.027.042-.047.058M25.542 1.015l.019.025c.07.028.074.103.111.155.03.019.036.052.053.08l.047.076c.05.041.073.103.11.154.039.024.051.064.068.101.001.05.029.089.057.128.029.041.064.083.023.139.02-.025.042-.036.068-.04.113.05.15.156.195.257.015.073.016.157.123.158.018-.045.002-.092.009-.138.005-.04-.002-.088.058-.096.056.018.029.06.036.08.006-.032.013-.08-.024-.117-.076-.075-.076-.169-.076-.266V.737c0-.043-.002-.087.006-.13.007-.04.02-.078.071-.075.06.002.05.05.05.087v1.07c.002.036.024.014.007.02-.005.001-.007-.002-.007-.009.003-.35 0-.702 0-1.052 0-.051.025-.12-.069-.123-.029-.001-.038-.03-.034-.06.004-.024.02-.04.044-.04.043-.005.085-.025.127-.023.186.007.371-.014.557-.01.03.001.06.002.082.03.027.053.02.11.02.166v2.69c0 .06.01.122-.025.178-.04.042-.093.037-.144.037-.287 0-.574.004-.861-.001-.045-.004-.087-.022-.11-.06-.095-.162-.227-.3-.314-.468 0-.041-.014-.079-.032-.115-.02-.058.056-.17-.093-.155-.027.002-.041-.053-.064-.078-.03-.033-.043-.089-.103-.09-.102-.078-.146-.2-.22-.3-.14-.187-.276-.378-.404-.573-.017-.026-.029-.053-.029-.084-.003-.012.008-.027-.005-.038-.008.01-.003.022-.003.033 0 .033.002.066-.01.098-.01.384-.002.768-.004 1.152-.002.173.002.346-.006.519 0 .049.007.1-.035.137-.109.045-.222.022-.333.022-.151 0-.303.02-.453-.014-.032-.016-.04-.044-.039-.076.003-.017.004-.037.017-.047.088-.076.087-.158.025-.248-.012-.017-.016-.04-.022-.06-.01-.069-.01-.137.004-.204.02-.06.013-.12.013-.18 0-.566.003-1.132 0-1.698-.002-.144.009-.283.072-.415.022-.03.055-.041.09-.04.266 0 .532-.023.797.016.054-.051.101-.13.188-.048.057.052.104.11.125.186-.007.036-.049.092.042.072.026.004.04.021.047.045L25.382.78c.012.005.017.014.017.026-.002.076.042.123.1.16.022.01.037.025.043.049M17.035 7.519c-.001-1.003-.002-2.006-.005-3.008 0-.164.114-.076.183-.09.012.01.025.017.04.022.532.009 1.063 0 1.594.004.014 0 .028 0 .042.002.064.025.128-.005.192.001.012.003.023.008.032.015.008.011.003.024.006.037.123-.054.24.022.36.016.03 0 .057.007.076.033.015.034.042.018.066.017.032.01.07.012.072.06-.008.02-.023.036-.034.069.059-.008.107.018.159.032l.042.034c.062.015.081.065.097.118.017.08.025.166.102.22.06.054.046.119.025.185-.005.09.007.18.001.27-.008.09-.036.174-.055.26-.025.134-.129.222-.193.333-.04.04-.085.075-.144.084-.147.051-.287.12-.433.175.008.025.02.047.044.06.014.01.026.022.036.036.028.05.08.084.099.14.01.042.036.068.077.08.03.011.048.032.055.063.024.092.097.14.171.187.186.107.308.278.437.442.033.027.092.045.036.102-.285.029-.57.005-.838.014h.711c.061 0 .12-.004.18-.02.05.045.02.06-.025.074-.084.024-.17.035-.255.02-.244-.043-.488-.02-.731-.015-.063-.01-.034-.116-.114-.109-.012-.003-.02-.01-.026-.02v.001c-.068-.079-.145-.149-.216-.226-.007-.01-.01-.02-.01-.033-.096-.205-.262-.348-.43-.488l-.073-.082c-.039-.054-.072-.111-.119-.159-.096-.071-.2-.04-.302-.023-.067.013-.056.066-.056.112l-.001.845c0 .046.015.096-.019.138l-.02-.005c-.215.005-.43.002-.646.002-.045 0-.097.014-.129-.037-.02-.059-.013-.12-.013-.18V5.129c0-.189-.025-.377-.013-.566-.006.018 0 .035 0 .053.026.953.005 1.907.015 2.86.004.016.003.031-.004.047-.016.007-.031.005-.046-.004M15.493 2.023l-.028.018c-.003.011-.01.019-.023.02-.049.007-.078.047-.117.07-.058.038-.12.072-.155.136-.01.014-.024.027-.039.037-.047.029-.1.045-.152.06-.09.023-.07.063-.022.11.015.018.027.037.037.058.011.04.042.062.076.079.015.01.025.025.032.04.014.075.09.099.127.156.013.022.05.044.046.057-.023.098.071.078.108.115.015.015.032.028.046.043.088.11.205.192.282.31.022.034.058.032.09.039.035.02.053.046.024.084-.046.044-.104.037-.16.038-.211 0-.424-.003-.635.001-.104.002-.197-.02-.28-.083-.055-.025-.105-.057-.127-.12-.012-.093-.082-.136-.154-.179-.052-.04-.119-.067-.134-.142-.048-.09-.064-.209-.196-.227-.032-.006-.051-.027-.063-.056-.008-.068-.048-.109-.112-.13-.045-.022-.08-.057-.11-.097-.088-.064-.198.021-.288-.04-.009-.05.03-.04.057-.042.053-.004.107.005.13 0-.024.01-.08-.003-.134-.002-.05 0-.084.012-.07.073-.01.273-.006.547-.008.82 0 .056.009.112-.012.166-.02.031-.05.052-.086.052-.258.003-.517.028-.774-.013-.015-.01-.023-.024-.023-.042.016-.181.003-.363.002-.544-.005-.572-.009-1.144.001-1.715.004-.208-.012-.416.002-.623-.005-.117.051-.154.167-.153.524.005 1.047.002 1.57.003.031 0 .068-.019.097.023-.02-.045-.054-.024-.078-.024-.567.001-1.133-.005-1.7.002-.018 0-.035-.002-.05-.012.013-.08.075-.04.112-.04.613-.003 1.227-.002 1.84-.002.061 0 .121.003.181.008.076.005.144.024.209.06.094.051.21.063.283.154.046.092.157.118.207.207.028.051.054.106.123.114.154.25.125.517.077.786-.08.003-.048.059-.046.1-.035.092-.072.182-.15.247M2.973.72l.07.11c.048.074.095.149.13.23.056.181.156.344.213.525.03.028.039.067.05.105.033.052.047.114.075.17.012.058.023.117.075.158.033.049.056.103.083.156.08.11.108.244.162.365.126.28.286.543.398.829.057.145.052.155-.102.154-.23-.003-.459.004-.688.013-.048.002-.096 0-.14-.02-.023-.009-.03-.029 0-.043.255.006.51-.018.763.012V3.47h-.77c-.086 0-.096-.074-.124-.13-.057-.162-.135-.316-.21-.472 0-.02.003-.038.008-.056.016-.053.017-.102-.031-.15 0 .121-.083.125-.169.126h-.853c-.102.001-.206-.013-.304.035-.03.015-.067.013-.094-.02-.04-.05-.026.006-.034.019-.006.026-.014.052-.003.08-.026.1-.057.198-.128.277-.062.043-.068.114-.094.175-.02.05-.025.11-.088.13-.274.015-.547.017-.82 0-.032-.01-.05-.031-.054-.065 0-.013 0-.027.004-.04.018-.049.044-.094.056-.145.042-.158.127-.297.191-.446.088-.201.174-.403.27-.6.041-.083.062-.179.131-.246.028.003.125-.061.132-.086.014-.047-.007-.093.003-.139.03-.06.074-.118.054-.193.016-.058.04-.112.076-.16.112-.111.14-.262.187-.404.003-.04-.01-.085.034-.113.097-.04.103-.128.113-.214 0-.045.022-.081.052-.113h-.001c.019-.057.021-.122.081-.157h1.06c.034.015.074.02.1.05l.08.182c-.014.05.023.086.038.129.006.016.021.019.01.005l.008-.01M23.433 2.656l.078.203c-.017.093.099.17.03.268-.006.008 0-.001.004 0 .067.016.132.11.126.175-.006.057-.051.037-.08.037-.207 0-.414.003-.62 0 .216.003.432.003.649 0 .064 0 .111.012.116.087-.014.06-.064.065-.111.066-.228.003-.456-.001-.684.002-.105.001-.136-.076-.182-.14-.069-.05-.066-.144-.122-.2-.024-.04-.034-.084-.04-.13-.002-.036-.01-.072-.015-.11V2.89c0-.055.063-.107.026-.158-.048-.067-.081.058-.135.023-.007-.004-.017-.001-.026-.002-.013-.002-.025-.005-.038-.01-.392-.014-.785.008-1.178-.01-.014-.001-.038-.012-.034.016.018.11-.073.081-.126.101-.075.018-.1.085-.118.144-.036.111-.075.22-.135.322-.02.034-.013.065-.003.099-.013.037-.02.08-.074.08-.29 0-.579-.006-.868.004-.08-.011-.063-.067-.05-.117.017-.058.057-.107.064-.169.001-.012.004-.024.007-.036.004-.012.01-.022.017-.032.013-.012.03-.017.046-.02.058-.031.054-.09.065-.143.007-.041.02-.08.035-.12.02-.04.034-.087.079-.112.048.023.037-.029.054-.044.037-.084.053-.177.13-.24.052-.043.01-.092 0-.139-.005-.046.014-.085.035-.122.1-.177.17-.368.276-.54l.02-.05c.026-.058.02-.131.084-.17.1-.148.19-.301.211-.484 0-.013.002-.025.006-.037.066-.104.096-.227.167-.328.11-.289.03-.245.346-.248.26-.002.519 0 .779 0 .04.032.022.05-.017.05-.077 0-.153.012-.232.004-.207-.019-.414.018-.621-.001.218.015.436-.012.654.003.086.006.177.024.253-.038.013-.019.031-.018.05-.017.066.047.066.135.118.191l.015.03c.01.039.032.069.062.094.031.036.03.09.07.12.052.121.116.238.138.37.002.12.055.216.144.294.043.023.047.065.052.106.038.187.103.362.235.505.033.024.035.065.055.096.058.173.152.33.213.502M29.545 5.094l-.017.005c-.468-.003-.937 0-1.406-.002-.074 0-.146.005-.208.054-.02.032-.068.031-.08.072-.01.021-.022.04-.048.043-.05.01-.067.058-.102.085-.022.027-.049.05-.046.093.03-.001.038-.062.078-.03.016.021.021.046.025.071.007.043.007.086.027.126.025.05.047.082.123.08.275-.009.549-.022.823-.045.205-.022.403.04.604.05.198.042.345.158.464.315.124.127.143.288.148.453-.016.058-.018.116-.001.174-.005.172-.047.332-.152.472-.007.025-.026.04-.048.053-.024.005-.044-.006-.065-.017l-.025-.022c-.13-.01-.249-.105-.402-.052.077.07.045.178.117.249.023.023.008.066-.01.098-.176.092-.368.102-.56.112h-1.68c.526 0 1.053 0 1.58.002.063 0 .129-.02.19.015-.086.073-.192.041-.287.045-.273.01-.546.007-.819.002-.208-.003-.415.02-.623.014-.15-.004-.184-.034-.181-.186.003-.177-.02-.355.03-.528.015-.01.032-.014.05-.014h1.688c.017 0 .034-.001.043.018l-.002-.019H27.16c-.051 0-.104.007-.155-.007.01-.094.084-.055.129-.055.435-.004.87-.003 1.305-.002.117 0 .232-.003.348-.009.043.004.084.018.127.026.034.007.07.062.101.014.026-.04.051-.092.009-.141-.01-.024 0-.043.016-.06.024-.04.038-.08-.007-.115-.018-.021-.01-.046-.01-.07-.05-.108-.141-.14-.253-.14-.276 0-.553-.003-.83.001-.108.001-.213-.022-.318-.04-.096-.017-.18-.059-.242-.138-.022-.029-.049-.05-.088-.045-.044.007-.087.004-.13-.002-.13-.089-.194-.223-.242-.365-.018-.052-.036-.105-.047-.16.025-.148-.03-.304.037-.45.059-.04.07-.11.098-.17.006-.01.013-.02.02-.028.059-.057.09-.132.135-.197.025-.041.06-.072.1-.096l.001-.001c.06-.077.155-.09.235-.129.043-.038.095-.044.148-.047l.042.007c.65-.055 1.3-.01 1.95-.023.064-.001.12.018.152.08.029.144-.09.232-.134.348-.099-.001-.062.066-.058.117-.003.044-.007.088-.054.111M24.661 5.585l.05.008c.333.017.667.011 1 .013.029 0 .064-.01.072.034-.088.034-.179.014-.268.016-.235.003-.47 0-.666 0 .293.005.624-.002.955.004.159.013.31.058.46.11.012.003.023.007.034.013.036.026.064.067.118.057.053.02.096.05.1.114.004.02-.043.033-.002.06.057.04.092.102.139.152.023.026.036.054.03.09.017.156.01.314.027.47.013.226-.2.57-.456.662-.013.001-.028-.002-.038.003-.219.101-.456.12-.689.16-.53.009-1.058.003-1.587.003-.03 0-.06-.001-.09-.013-.02-.012-.037-.025-.021-.052.023-.027.056-.046.09-.045.12.005.165-.038.112-.156-.003-.007-.001-.017-.003-.025-.013-.073.042-.16.005-.213-.038-.054-.141.003-.205-.046-.034-.042-.035-.084.004-.124.056-.032.118-.022.177-.022h1.538c.085.007.167.001.221-.079.02-.029.03-.061.03-.097 0-.073.017-.151-.048-.21-.01-.008-.019-.017-.028-.027-.009-.01-.019-.019-.03-.026-.11-.057-.23-.041-.344-.043-.246-.004-.491-.026-.737-.016-.027-.005-.07.009-.052-.046.32-.013.641-.002.962-.007-.337.004-.673-.002-1.01.002-.091 0-.178-.034-.266-.053-.222-.031-.443-.236-.488-.452.07-.188.08-.383.067-.58-.001-.032-.008-.06-.036-.078-.07-.077.02-.132.028-.198.015-.03.024-.06.023-.094.009-.026.024-.049.04-.07.182-.179.392-.3.646-.34.05-.026.11.007.16-.021.573-.016 1.146-.01 1.719-.003-.06.083-.147.02-.219.04H24.99h1.19c.072.005.146-.01.225.012-.028.072-.09.068-.14.061-.383-.05-.766-.004-1.06-.02.228-.001.544 0 .86-.002.086 0 .165.016.235.063.11.075.105.19-.011.252-.06.032-.005.078-.022.113-.018.108-.098.117-.186.117h-1.124c-.046 0-.095-.012-.138.016-.012.023-.042.035-.047.065-.011.029-.039.036-.063.048l-.027.014c-.023.013-.04.03-.053.054-.004.01-.01.019-.015.028-.023.043-.032.087-.018.135l.01.032c.02.045.017.1.056.137M17.753 1.007c.003-.021.013-.038.033-.048.054-.004.073-.046.096-.085.046-.019.07-.055.097-.095.054-.081.156-.112.216-.19.02-.029.053-.037.085-.047.034-.008.069-.014.1-.029.093-.046.18-.051.261.043 0-.095.035-.15.117-.169.041-.01.08-.027.12-.04.234-.004.466-.034.7-.033.182 0 .361.036.542.032.07-.001.1.042.095.096-.02.182.011.363.004.545-.002.038-.008.078-.044.104-.064-.016-.04-.063-.039-.104.012-.185.007-.37 0-.555.005.171.008.343.004.514-.002.104-.072.126-.16.126h-.701c-.096 0-.19.003-.283.03-.038.012-.078.018-.12.017-.036 0-.018.023-.018.039-.145.077-.248.21-.386.295-.075.037-.052.121-.087.175-.03.047.023.146-.089.143-.014 0 .003.014.005.019.082.15.024.322.07.479.01.036-.023.072-.075.078.115-.027.153.071.218.125.022.009.043.019.061.033.023.019.043.04.064.06.035.033.066.069.092.11.111.096.243.125.387.122h.41c.06 0 .122-.001.161.058.02.034.019.068.003.102-.01.017-.022.03-.04.038-.071.014-.025.075-.044.11-.008.038-.03.067-.06.09-.02.012-.02.031-.02.05-.017.02-.006.057-.038.068-.034.01-.04.046-.059.07-.01.006-.02.01-.03.01-.053.092-.138.1-.234.1-.178.003-.352-.027-.528-.05-.039-.007-.076-.017-.101-.052-.038-.182-.125-.287-.248-.3-.026-.002-.061-.013-.075.005-.062.082-.12.03-.159-.013-.062-.068-.13-.095-.217-.078-.108-.04-.116-.153-.169-.234.006-.048-.027-.077-.054-.11-.121-.236-.137-.494-.135-.752.001-.134 0-.272.05-.402.057-.161.092-.332.203-.47.017-.002.022-.013.02-.03",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M20.337 1.193c.009.099.01.2.028.297.025.145-.004.288-.002.432 0 .036-.005.075.052.052.016.014.016.032.01.05-.027.036-.065.04-.105.038-.026 0-.059-.01-.076.007-.078.078-.155.1-.23-.004-.044.066.006.096.016.134.004.012.005.023.003.035-.018.036-.057.059-.064.101-.003.013-.008.024-.012.036-.036.101-.119.117-.21.113-.087-.003-.167.002-.205.099-.012.03-.044.044-.075.044-.145 0-.295.039-.43-.054-.05-.035-.102-.037-.16-.014-.06.025-.125.033-.186-.006-.027-.14-.077-.273-.12-.408-.009-.03-.017-.069.003-.088.08-.078.046-.17.036-.256-.015-.138.052-.26.059-.395.004-.073.214-.18.29-.16.055.016.093.008.121-.041.023-.041.057-.069.103-.069.316.003.63-.024.946.002.036.011.073.01.11.006.04.002.075.012.098.049",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAF5",
    d: "M19.217 7.546c.069.038.142.016.213.017.254.003.507.003.76 0 .02-.001.097.046.069-.045-.012-.005-.021-.013-.026-.025l-.054-.077c.059.006.13.063.152-.05.046.04.029.078.025.115-.003.03-.025.075.022.084.04.009.057-.032.07-.064.028-.064.046-.129.046-.2-.001-.755.008-1.51-.007-2.265-.004-.176.009-.361-.052-.538-.016-.046-.045-.115.03-.17.035-.024-.033-.105 0-.164.011-.018.008-.047.036-.044.014.001.033.018.037.032.021.078.07.116.15.132.01.002.109.008.07.092-.013.026.038.018.06.018.789 0 1.579 0 2.368.002.061 0 .088-.034.124-.077.035.084.05.158.048.237-.002.159 0 .318.001.477.002.116-.064.144-.167.144-.473-.003-.946-.001-1.42-.001h-.127v.033h1.61c-.035.056-.078.044-.117.044l-1.393.001c-.065 0-.147-.027-.14.092-.065-.038-.026-.081-.035-.115-.006-.026-.017-.052-.05-.05-.035.003-.035.033-.037.059-.003.04.023.071.034.106.013.04.156.061.031.132.05.034.069.113.141.113.473.002.946.001 1.419 0 .024 0 .06-.007.07-.024.086-.128.095-.054.11.037.036.237.013.474.01.712 0 .008-.016.017-.026.026-.048-.071-.024-.151-.028-.227-.01-.142.014-.285-.015-.426-.01-.011-.022-.02-.036-.027-.407-.017-.814-.002-1.22-.007-.147-.002-.295 0-.442-.001-.09-.002-.135-.045-.136-.136-.001-.086-.003-.173 0-.26.003-.14.036-.175.18-.173.363.004.726.002 1.09.001.19 0 .38.013.57-.01.011-.008.02-.019.027-.032.02-.167 0-.335.012-.502.002-.033-.012-.058-.042-.074-.042-.014-.086-.01-.129-.01h-2.405c-.024.001-.048.001-.07.01-.054.028-.045.08-.045.126v2.803c0 .039-.003.079.025.11.037.032.081.026.124.026h2.39c.052 0 .117.018.138-.06 0-.015.003-.03.006-.046-.003-.172.02-.344-.014-.514-.046-.05-.106-.034-.16-.034l-1.481-.001c-.197 0-.215-.02-.217-.216 0-.06-.002-.12 0-.181.006-.14.03-.168.17-.17.3-.003.598 0 .897 0 .22 0 .442-.002.663 0 .05 0 .105-.007.149.03.001.073-.046.053-.09.05-.53-.037-1.06-.012-1.591-.013-.01 0-.02.014-.031.021-.012.025-.054.04-.026.078v.026c.002.045-.022.076-.052.104-.006.038-.01.077-.018.114-.015.074.026.104.086.09.18-.043.362-.017.543-.02.312-.005.624 0 .936-.002.12 0 .284.06.25-.2.077.086.035.159.06.23.026-.047.063-.061.111-.056.043.005.078.016.085.063.005.034.017.076-.011.098-.034.026-.052-.04-.09-.03-.049-.015-.022.047-.052.052-.055.142-.015.29-.022.434-.001.022.016.045.038.047.037.002.032-.031.036-.056.006-.04-.015-.086.027-.13.052.063.003.144.047.22.065-.144.001-.29.059-.42.029.155.038.308-.004.462-.005.017-.011.032-.033.032-.095 0-.13.062-.138.158-.053-.116-.156-.091-.227-.092-.798-.007-1.596-.003-2.394-.007-.096 0-.09.058-.095.115-.005.049.001.1-.072.095-.072-.005-.047-.047-.044-.092.007-.101-.08-.071-.116-.054-.067.032-.115.028-.156-.028-.032-.044-.06-.016-.09-.003-.056.024-.112.047-.164.077-.05.028-.08.027-.09-.037-.007-.054-.044-.07-.092-.07h-.495c-.027 0-.052.004-.06.05.038.004.077-.052.117.004-.063.04-.067.162-.183.127-.123-.037-.134-.127-.093-.233.013-.015.03-.02.049-.018.011.003.021.009.03.019",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFCFA",
    d: "M9.402 7.649c.03.021.079.034.054.085-.012.025-.035.057-.059.063-.052.012-.06-.042-.073-.074-.032-.08-.09-.08-.162-.07.008.06.061.04.093.057-.008.014-.011.027-.02.033-.073.052-.158.033-.237.033-.776.004-1.552.003-2.328.002-.108 0-.208-.156-.254-.234-.105-.178.043-.379-.078-.546-.02-.026-.008-.076-.008-.115 0-.594-.008-1.188.005-1.781.004-.141-.048-.29.031-.43.03-.052-.049-.127-.112-.113-.024.006-.045.012-.05-.016-.004-.024-.001-.072.005-.073.091-.018.15-.114.25-.102.02.015.052.005.064.033.01.036-.004.06-.035.078-.016.01-.073-.011-.05.014.088.103.041.22.054.33.004.038.013.076.015.114 0 .022-.005.043-.015.063-.026.048-.021.1-.021.152v1.671c0 .06-.002.121.035.174.031.124.012.25.016.375.007.173.03.191.196.19.766-.004 1.533-.002 2.3-.001.087 0 .17.034.258.027.05.004.096.016.126.06",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 7) translate(24.78 .065)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "56gw78n09b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i31x10s1ta"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F9F6",
    d: "M1.051 2.872c.11.182.232.355.362.522.038.025.081.025.125.025.271 0 .543.001.815-.001.042 0 .1.021.116-.048 0-1.004.002-2.009 0-3.013-.009-.015-.02-.025-.037-.03-.207-.009-.414.011-.621 0-.15-.007-.161.01-.16.16.001.463-.01.926.004 1.388.003.093.006.19-.02.283-.112.036-.117-.053-.142-.12-.04-.101-.108-.185-.177-.268-.087-.048-.126-.128-.15-.22 0-.012.006-.023.016-.032.031-.014.062-.037.08.02.01.032.033.06.05.09.017.025.034.06.066.055.036-.005.035-.043.037-.074.001-.017.006-.033.011-.059.073.034.07.124.136.153.028-.055.036-.112.036-.174-.002-.373 0-.746-.002-1.119 0-.063.024-.153-.1-.124-.028.006-.046-.02-.05-.048-.003-.026.012-.046.036-.044.07.008.122-.043.183-.05.054-.006.132-.046.163.048.004.011.03.025.043.022.196-.036.38.072.573.044.07-.01.086.016.09.073V3.167c.001.05-.019.105.026.148.07.11.043.158-.104.182H1.82c-.112 0-.222-.01-.32.07-.052.044-.26-.06-.26-.124.002-.043.076-.058.045-.131-.044-.104-.135-.165-.195-.254-.04-.06-.073-.123-.114-.181-.058-.084-.138-.138-.234-.179-.057-.024-.052.005-.066.036-.011.026-.022.063-.062.053-.04-.01-.038-.051-.03-.076.028-.073.004-.15.026-.222.042-.136.032-.163-.103-.233C.485 2.244.483 2.222.477 2.2c-.01-.037.009-.108-.073-.07.037-.152-.117-.108-.169-.167-.02-.023-.016-.075-.012-.112.008-.072-.081-.08-.086-.14l-.048.041c-.05-.13-.04-.163.049-.183l.624.89c.118.094.186.225.262.35.018.016.025.038.027.062",
    mask: "url(#56gw78n09b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F7FAF9",
    d: "M20.155 1.167h-.916c-.06 0-.114-.01-.135.078-.015.061-.08.08-.146.04-.048-.028-.112-.084-.114.038-.166.023-.128.162-.167.269-.045.126-.035.239-.002.358.006.02.026.05.01.055-.188.058-.072.196-.039.257.052.097.046.188.05.284.015.014.016.03.01.048-.038.028-.061-.03-.097-.017l-.046-.048c-.193-.26-.224-.55-.164-.859.01-.05.03-.1.025-.152.004-.036.01-.071.048-.088.12-.106.227-.23.384-.287.026-.036.07-.03.106-.043.013-.005.026-.009.04-.01.052.005.097-.026.149-.026.293-.003.587-.001.88-.001.042 0 .087-.01.124.022.057-.132.02-.27.023-.405.006-.322.002-.322-.319-.322-.272 0-.545 0-.817.002-.064 0-.13-.007-.191.023-.048.03-.11.005-.156.039-.138.032-.266.101-.412.1l-.049-.086c.076.044.158.029.207-.01.137-.105.291-.09.445-.093.088-.002.184.028.25-.066.009-.012.04-.01.061-.01.217-.002.436-.022.649.007.114.016.224.068.348.072.092.003.073.108.059.171-.018.08-.023.16-.016.241.038-.004.008-.05.04-.056.09.132.08.31-.02.413.106.006.106.006.08.088-.035-.01-.07-.018-.104-.026-.026-.021-.052.005-.078 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M5.158 3.353c-.042.015-.043.134-.097.074-.15-.17-.341-.009-.514-.1.095 0 .173-.006.251.002.115.012.157-.023.155-.148-.008-.441.006-.883-.007-1.324-.006-.212.11-.406.059-.62.057.065.069.238.027.333-.026.058-.031.116-.03.177 0 .048.022.07.07.07.05 0 .083-.009.087-.069.005-.098.016-.196.025-.295.012-.007.022-.006.03.005.016.036.004.072.008.096-.002-.027.013-.066-.013-.102-.021-.049-.013-.1-.013-.148-.022.047.02.1-.012.149-.015.019-.029.053-.045.054-.03.002-.031-.033-.032-.057-.002-.043.006-.087-.002-.128-.016-.076.035-.102.087-.11.065-.012.07.045.075.093.023.03.055.057.021.098-.001.659-.005 1.318-.002 1.977 0 .1-.02.138-.127.134-.208-.009-.416-.001-.624-.003-.035 0-.08.02-.104-.027.222-.03.445-.004.667-.014.048-.002.106.023.138-.04l-.078-.077c.027-.029.017-.063.016-.098-.005-.396-.001-.792-.002-1.052.005.273-.011.682.006 1.09 0 .023-.007.043-.02.06",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F9F6",
    d: "M16.588 5.957l-.026.156c-.109.156-.239.287-.417.364-.229.12-.485.13-.728.12-.25-.01-.5 0-.75-.017-.122-.009-.167.03-.165.159.001.193.01.387-.01.581-.008.076.02.171.03.258.003.032.008.077-.032.062-.125-.044-.252.007-.376-.017-.136-.029-.274-.013-.411-.008-.04.001-.076.01-.11-.018l-.103.026c-.038-.046.002-.108-.035-.154.06-.077-.018-.17.026-.249.033-.044.025-.095.024-.145-.008-.828.01-1.655-.011-2.482-.065-.007-.122.04-.17-.013-.021-.022-.028-.046-.014-.074.004-.022.037-.03.026-.057-.003-.006-.022 0-.034.002-.02.004-.04.005-.06.005h-.758c-.063.005-.13-.017-.188.025-.057.043-.106.093-.144.153-.025.033-.055.062-.083.092-.054.048-.097.11-.168.137-.05.008-.076.048-.108.081-.033.035-.064.085-.126.05-.055-.045-.102-.097.015-.109.082-.009.069-.045.044-.093-.014-.026-.029-.055-.052-.072-.032-.023-.072-.037-.052-.087.01-.027.033-.022.054-.013.036.015.091 0 .095.066.003.034-.019.091.042.09.047 0 .07-.053.08-.09.022-.083.069-.11.15-.121.099-.012.187-.195.15-.304-.012-.034-.04-.062.003-.087.035-.022.076-.02.112-.002.042.023.027.056.012.09-.014.03-.046.064-.01.093.03.024.063.022.08-.026.005-.015.038-.013.044.002.038.1.123.06.19.062.177.004.355.001.532.001.052 0 .105.004.151-.026.026-.02.052-.022.078 0 .077-.043.107.08.18.05l.018.018c.032.061.02.128.02.192.002.893.001 1.787.002 2.68 0 .064-.01.13.02.191.004.003.006.009.01.01.254.04.508.047.762-.006.037-.082.017-.169.018-.253.004-.189 0-.377.002-.566 0-.055-.007-.112.034-.16.052-.04.114-.03.174-.03.284-.002.569-.002.853-.001.378.014.697-.112.946-.402.015-.02.03-.04.043-.061.026-.032.045-.073.09-.087.012 0 .022.004.03.014",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF6F6",
    d: "M25.785 5.64c-.291-.037-.585-.006-.877-.018-.067-.003-.137.014-.197-.03.078-.045.153-.107.242-.013.014.015.05.012.075.012.346.006.692-.016 1.037.027.052-.033.092-.009.13.026h.052c.053.003.082.036.104.078.1.09.204.175.297.271.02.021.072.05.031.122-.024.043.043.137.07.21.074-.085-.036-.188.04-.276.048.072.057.162.048.23-.011.09.017.208-.025.261-.118.151.009.369-.161.499-.04.03-.039.11-.041.172-.004.088-.063.117-.146.087-.047-.017-.073.03-.087.058-.02.041-.039.068-.084.084-.138.049-.274.104-.41.156-.044.033-.087.032-.13 0h-.079c-.044.024-.093.012-.14.013-.518 0-1.037 0-1.555.002-.008 0-.015.008-.023.012-.08-.035-.042.088-.104.078-.107.026-.039-.08-.078-.105-.012-.045-.08-.047-.078-.104.025-.03.056-.06.026-.104v-.13c.017-.095.034-.19-.021-.279-.017-.026-.016-.056-.005-.085.067-.039.109-.13.208-.104.043.02.087.02.13 0l1.428-.001c.045 0 .096.017.134-.025.021-.037.053-.058.093-.068.041 0 .069.018.08.059 0 .025-.007.045-.028.06-.06.053-.134.053-.208.053H23.99c-.051 0-.104-.005-.155.006-.026.013-.036.036-.033.063.02.193-.004.386.008.58.008.012.02.02.035.024.558.008 1.115.007 1.673.001.255-.003.501-.064.732-.178.272-.121.39-.35.437-.628-.013-.018-.011-.037-.005-.057.01-.093.013-.185-.002-.278-.004-.053-.027-.103-.018-.157.007-.032-.01-.055-.026-.08-.04-.07-.132-.11-.13-.207-.016-.053-.057-.082-.102-.107-.047.005-.074-.027-.104-.054l.002.001c-.143-.063-.289-.116-.447-.127-.027-.001-.054-.003-.07-.03",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAF8",
    d: "M17.056 3.535c-.055.19-.21.156-.35.157-.083 0-.167-.012-.246.002-.228.041-.343-.096-.445-.263-.014-.017-.016-.034 0-.052.063-.03.08-.082.08-.149-.003-.35-.002-.7-.002-1.05 0-.026.004-.064-.01-.075-.188-.145-.078-.34-.079-.511 0-.146.018-.29-.005-.437-.017-.115-.026-.232.017-.345.04-.1.025-.205.022-.307-.003-.087-.05-.148-.151-.164.096-.082.177-.045.258-.007.054.113.031.236.033.352.007.823.004 1.646.005 2.47 0 .077-.023.152-.017.232.007.084.039.113.12.112.203-.003.407-.002.61 0 .056 0 .115-.01.16.035",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6FAF6",
    d: "M28.851 6.84c-.57 0-1.142.001-1.713.004-.043 0-.095-.025-.13.025.006.006.007.011.005.016-.003.005-.006.007-.008.007-.002.19 0 .382-.009.571-.005.098.044.103.118.102.46-.001.919.001 1.378-.002.13 0 .26.02.387-.015l.013-.016c.196-.032.395-.056.562-.179.1-.045.17-.132.26-.19l.046-.036c.01-.012.02-.012.028.001-.045.127-.127.242-.234.3-.117.065-.18.233-.358.186.109.042.22.001.336.058-.096.051-.19.038-.273.039-.084.001-.172-.004-.258-.01-.038-.004-.082.012-.067-.067.011-.063-.065-.04-.097-.035-.328.04-.657.027-.986.02-.247-.004-.492.042-.738.027-.096-.005-.1.096-.177.124-.017-.086-.014-.176-.082-.238-.01.003-.021.004-.023.01-.017.042-.014.097-.07.114-.02.007-.034-.01-.038-.027-.013-.051-.016-.104.015-.15.014-.02.037-.049.056-.05.192-.003.134-.147.126-.242-.009-.103.082-.217-.034-.315-.017-.014-.005-.108.039-.139.055-.038.042.03.058.052.018.023.04.006.06.006l1.651-.002.016-.002c.035-.008.07-.018.102-.037.02-.014.046-.021.065-.038.028-.001.06.004.078-.026.023-.01.033.005.039.024.001.04-.024.068-.047.097-.029.02-.055.046-.096.032",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF4F4",
    d: "M12.655 3.431v.027c.037.032.081.025.123.025h.604c.05 0 .106.01.133-.051l.007-.892c0-.047-.008-.095.018-.139.011-.004.023-.006.035-.003.062.023.126.008.189.01.048.003.094.006.118.056.008.028.04.048.024.083-.023-.008-.06.018-.063-.04-.001-.023-.066-.092-.086-.02-.023.085-.084.032-.122.054-.028.017.007-.06-.033-.078-.048.02-.036.064-.033.098.023.28-.013.559-.002.839.002.052-.009.11.078.086.022-.006.046.007.047.032.002.039-.026.027-.052.03-.316.04-.632.001-.948.011-.091.004-.127-.076-.107-.144.052-.18.026-.356.023-.537-.01-.567-.015-1.135.002-1.703.007-.233.007-.462-.03-.692-.016-.095.02-.15.124-.15h2.158c.067 0 .1.038.137.082-.276-.073-.558-.056-.838-.056-.458 0-.917-.001-1.375.001-.043 0-.096-.026-.13.026.03.055.008.114.013.171.002.93-.005 1.859.004 2.788 0 .03.005.06-.018.086",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F4F3",
    d: "M10.235 2.39v.182c.053.039.007.127.078.156.047.03.1.027.151.027h1.416c.03 0 .067.009.09-.005.143-.081.136.031.138.11.005.217.002.433.002.65-.04-.004-.006.103-.078.052-.045-.026-.094-.013-.14-.013l-2.428-.001c-.047 0-.095.01-.14-.012-.034-.001-.052-.019-.053-.052-.045-.121.016-.238.016-.358-.003-.888-.002-1.776-.002-2.664 0-.034-.01-.07.011-.101L9.3.358c.018-.007.03-.002.04.014.033.07.016.144.022.216V3.26c0 .056-.006.112.01.167.024.047.07.045.112.045.82 0 1.642.002 2.462 0 .022 0 .043-.003.063-.011.03-.017.039-.044.04-.075.001-.159.002-.317-.001-.475 0-.024-.012-.04-.032-.052-.014-.005-.027-.01-.04-.013-.542-.007-1.082 0-1.622-.003-.033-.001-.066-.003-.098-.013-.077-.025-.108-.078-.108-.156 0-.095-.001-.19.001-.284.002-.064.015-.121.091-.135.025-.004.05-.005.074-.005h1.525c.06 0 .121-.01.178.02l.018.018c-.112.1-.25.058-.37.044-.266-.031-.533-.016-.799-.017-.166 0-.336-.032-.5.023-.032.044-.096.011-.13.052",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F7F8",
    d: "M13.464 7.466c.107.036.019.104.026.157l-.079.026c-.05.022-.09.006-.13-.026h-.833c-.034.027-.07.016-.104 0-.036.021-.045.095-.104.07-.052-.024-.01-.064 0-.096-.024-.021-.032-.048-.026-.078-.014-.055-.078-.041-.104-.079-.036-.037-.064-.08-.078-.13-.025-.044-.036-.103-.105-.104-.124-.114-.26-.219-.317-.388.008-.01.019-.015.031-.017.114.02.163.12.229.195.065.074.13.148.2.217.052.049.09.112.14.165.03.032.063.062.096.092.037.037.078.065.135.065.296 0 .592.002.888-.002.013 0 .025-.007.034-.015-.031-.124-.151-.173-.22-.265-.024-.024-.045-.051-.066-.078-.022-.026-.051-.043-.077-.066-.09-.08-.15-.184-.227-.275-.042-.048-.089-.093-.135-.137-.083-.093-.156-.194-.25-.277l-.062-.062c-.068-.063-.11-.15-.185-.207-.19-.17-.19-.174-.035-.364.021-.03.045-.057.07-.083.065-.068.12-.149.221-.17.056.053.022.092-.01.146-.052.09-.162.12-.207.214-.005.012-.016.02-.027.028.016-.004.025-.02.041-.025.013-.001.024.002.033.01.009.01.023.023.02.033-.03.137.078.2.149.282l.023.028c.153.186.302.375.474.544.056.055.117.103.164.166.019.033.032.072.08.072.059.007.047.053.05.09.007.061.073.059.101.097.015.017.025.037.035.056.014.03.033.056.057.079.024.04.09.05.084.112",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7F0F4",
    d: "M12.11.412c.01.176-.013.353.014.53.02.126-.03.172-.16.173h-1.572c-.166 0-.18.015-.158.174v.013c.023.229.023.229.252.229.473 0 .945.003 1.417-.002.12-.002.164.034.157.155-.009.16-.002.32-.003.481 0 .042.012.088-.023.123l-.004-.003c-.015-.019-.027-.04-.03-.063-.015-.14-.004-.282-.008-.423-.001-.05.007-.103-.027-.148-.047-.045-.106-.03-.16-.03-.515-.004-1.03.004-1.544-.005-.04-.008-.072-.027-.092-.063-.049-.084-.023-.424.038-.505.048-.026.1-.022.152-.022h1.662c.054-.027.023-.076.026-.115.013-.163-.023-.328.023-.49.01-.014.024-.017.04-.01",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFCFA",
    d: "M9.61 4.265c.09-.043.204-.03.277-.117.02-.023.055-.009.057.023.01.103.082.1.152.092.122-.011.248.035.366-.041.048-.031.085.03.122.054.024.015.04.037.06.001.013-.024.038-.057-.018-.065-.045-.006-.064-.03-.038-.07.026-.042.062-.038.1-.01.075.059.143.118.059.221-.03.036-.015.072.009.107.052.08.229.158.322.136.03-.008.062-.023.079.013.02.046-.014.063-.05.07-.039.006-.074.02-.06.064.02.067.062.017.09.006.041-.015.058-.004.061.036-.117.093-.15.093-.238-.02-.036-.045-.085-.072-.122-.112-.052-.051-.107-.099-.151-.159-.052-.07-.127-.101-.216-.086-.039.007-.076.016-.114-.003-.14-.09-.278-.07-.415.008-.155.035-.315-.01-.47.026-.101.01-.192-.021-.28-.065.006-.08.072-.056.116-.066.1-.024.206.006.302-.043",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9F7",
    d: "M19.56 6.788c-.017-.02-.035-.038-.053-.056-.026-.004-.04-.022-.05-.044-.02-.083-.092-.125-.146-.18l-.02-.022c-.005-.087.052-.098.119-.099l.016.012c.027.06.09.09.113.156.017.045.071.068.12.035.038-.026.077-.03.12-.038.167-.03.192-.003.147.172-.04-.003-.04-.094-.095-.054-.053.039-.1.088-.14.139-.012.015.017.047.04.06.033.018.031-.014.038-.031.019-.048.064-.052.1-.07.008.013.017.024.015.026-.089.108-.097.181.07.214.043.008.115.036.117.12.002.043.06.038.094.048.041.012.065-.012.07-.055 0-.004 0-.009.003-.012.028-.037.046-.085.095-.098.026-.007.034.023.043.041.029.06-.018.08-.053.114-.047.044-.048.14-.146.127.01.04.019.082.002.123l-.318-.323c-.036-.037-.065-.08-.119-.095-.061-.07-.15-.116-.182-.21",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2070B7",
    d: "M25.157.484c-.069-.038-.096.022-.133.058L25.008.53c-.02-.043-.055-.059-.103-.058-.244.001-.488.002-.732 0-.028 0-.052 0-.046.04-.002.011-.006.022-.015.03-.112.738-.024 1.48-.052 2.221-.001.034.007.07-.026.096-.017-.023-.012-.05-.012-.075V.653c0 .01-.029.027-.012.024.025.828.001 1.657.009 2.485-.005.017.013.004.011 0-.016-.031-.012-.064.004-.095.115.183.114.192-.026.312-.029-.021-.035-.054-.045-.086-.024-.207.001-.415-.003-.622-.011-.603-.003-1.206-.005-1.809 0-.117.025-.233.01-.35.004-.095.047-.146.15-.149.297-.006.593-.003.89 0 .04 0 .076.013.101.047l.04.03c.022.01.022.025.011.044",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 7) translate(.195 2.796)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "80bg8a6sdd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yb0ibnm2wc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ECF4F6",
    d: "M2.773.064c.097.142.151.304.213.463.013.03.02.055-.028.056-.042.049.015-.157-.061-.024C2.865.533 2.83.517 2.857.46c.054-.112-.026-.232-.136-.295C2.603.1 2.485.117 2.366.116 2.094.112 1.821.114 1.548.115c-.123 0-.262.102-.317.216-.046.093-.085.185-.105.289-.018.087-.088.14-.179.144C.687.774.428.756.169.772.116.775.035.747.007.682-.018.624.03.578.065.535.089.505.117.478.143.45l.014.013C.154.507.142.546.113.58h.004C.1.631.072.691.17.686c.267-.001.533.004.8-.002.062-.011.054-.07.073-.11.03-.066.043-.14.097-.192.055-.093.096-.192.127-.295.02-.04.054-.05.096-.052C1.802.013 2.24.03 2.68.028c.035 0 .069.006.093.036",
    mask: "url(#80bg8a6sdd)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DDEBF5",
    d: "M17.056 3.535l-.727.001c-.217 0-.24-.02-.202-.235.015-.083.016-.164.016-.245.001-.77.002-1.542 0-2.313 0-.136-.025-.273.002-.41.042-.024.085-.038.134-.038h.632c.044 0 .085.008.12.038V.36c-.047.042-.105.036-.161.036h-.508c-.14.002-.147.006-.148.147-.003.39-.001.781 0 1.172 0 .568-.002 1.136 0 1.704.015.057.061.054.104.054h.57c.044 0 .089.001.102-.056.01-.785.001-1.57.004-2.354 0-.204-.002-.408.001-.612.001-.017.004-.033.009-.05.007-.015.016-.029.027-.041.048.041.026.097.026.147.001.94.002 1.882 0 2.823 0 .069.024.137 0 .205",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFCFA",
    d: "M10.782 7.57c-.003.1.03.213-.098.268-.03.013-.06.027-.083 0-.085-.097-.178-.123-.3-.065-.047.022-.112.002-.168.006-.072.006-.158-.033-.207.064-.003.006-.094.077-.108-.04-.007-.053-.098-.024-.148-.022-.098.004-.151-.027-.138-.132.03-.082.094-.1.165-.072.07.028.141.025.212.03.037.044.029-.018.046-.021.187-.026.375-.076.548.049.015.01.033.007.05.003.046-.02.074.019.11.037.016-.055-.053-.077-.04-.126.061-.055.111-.026.159.022",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCE8F1",
    d: "M23.983.49l.001 2.838c.02.155.02.155.187.155h.569c.02 0 .042 0 .063.003.013.001.026.006.037.014.01.011.01.023.002.036-.259 0-.518-.002-.777.001-.112.002-.12-.05-.13-.152-.019-.198.044-.393-.001-.589-.008-.033-.004-.069-.004-.104 0-.62-.001-1.24.001-1.86 0-.14.017-.281.023-.421.002-.055.023-.078.078-.078l1.015.001c.024 0 .041.011.05.034-.28.01-.559 0-.838.004-.052.001-.104.007-.154.004-.088-.005-.118.036-.122.114",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F8F4",
    d: "M10.574 7.649c-.025.082-.09.065-.112.019-.037-.083-.097-.076-.159-.07-.118.01-.24-.03-.354.024-.009.011-.018.012-.026 0-.075.008-.149.037-.223-.016-.066-.047-.114.019-.168.043-.043-.052-.087-.052-.13 0l-.104-.027c-.014-.063.032-.097.065-.138.028-.021.058-.04.08-.066.03-.033.051-.07.057-.114.008-.07.066-.121.113-.124.124-.009.125-.096.144-.177.008-.01.02-.015.032-.015.033.01.054.033.07.062.007.018.008.036.006.055-.063.11-.136.213-.235.294-.033.033-.07.063-.091.105 0 .01.002.019.01.026.317.006.635.013.952-.004.022-.013.038-.032.057-.048.14-.095.22-.255.365-.346.043-.01.063-.073.119-.056.019.033.027.077.078.078.027.024.091.015.07.083-.005.017.014.044-.008.058-.029.017-.047-.01-.063-.027-.027-.033-.05-.079-.102-.055-.058.026-.032.079-.027.123l-.068-.042c-.054-.006.1.12-.06.068-.063-.02-.099.117-.08.209-.052 0-.104-.06-.156 0-.002.036-.03.055-.052.078",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F5F7",
    d: "M12.11.412h-.027c-.035-.01-.07-.017-.108-.016h-2.48c-.06 0-.122.01-.172-.037h-.024c.145-.026.29-.072.434-.074.7-.008 1.4-.001 2.1-.006.086 0 .151.069.243.046.03-.007.033.052.034.087",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECF5F4",
    d: "M22.626 3.028c-.013.045.029.076.028.117.015.017.015.035 0 .052-.076-.015-.105-.054-.096-.137.011-.1-.032-.154-.15-.152-.368.007-.737.001-1.104.003-.196.001-.269.082-.33.263-.03.088-.085.16-.04.257.005.013-.004.041-.028.032-.099-.036-.113.076-.178.098-.285-.016-.57-.026-.856.002-.031.003-.06-.002-.082-.027l-.026-.026c-.025-.038-.002-.06.026-.08v-.077c-.021-.107.056-.132.133-.157.003.104-.119.174-.077.287.303.004.606-.005.91.005.033-.018.029-.055.041-.083-.012-.024-.017-.05-.001-.074.08-.124.122-.266.182-.4.02-.045.043-.083.096-.095.481-.023.963-.02 1.444-.005.031.01.053.03.062.061.013.046.037.088.046.136",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9F5F8",
    d: "M7.841 3.503l.798.003c.012-.012.024-.01.034.003-.047.05-.075.162-.17.043-.032-.04-.08.009-.123.01-.173.005-.345-.009-.518.009-.078.008-.112-.06-.123-.127-.008-.047-.003-.095-.003-.143-.027-.132-.009-.266-.012-.4-.008-.276.011-.552-.013-.829-.005-.05-.007-.104.025-.15.041-.096.04-.191 0-.287-.025-.02-.001-.057-.026-.078-.074.107-.055.245-.126.356-.023.037-.034.063-.079.061l.231-.598c.024-.017.045-.017.062.01.005.18 0 .36.002.54v1.32c.014.086-.034.181.041.257",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F9F4",
    d: "M20.415 2.026v-.053c.118-.033.058-.173.14-.231.027-.02.03-.071.076-.078l-.294.675c.007.119-.095.195-.118.303-.014.04-.024.084-.069.105l-.069.113c-.072.088-.07.215-.157.294.003.006.002.012-.002.018-.083-.014-.053-.102-.093-.144-.013-.041-.054-.054-.08-.08-.037-.034-.052-.074.014-.096.035.017.075.023.11.04.047.024.073.007.088-.037.014-.042.028-.09-.029-.109-.045-.014-.082-.031-.08-.084.003-.058.052-.083.096-.092.176-.038.219-.158.209-.317-.005-.074.031-.132.104-.142.068-.008.11-.046.154-.085",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7FAF6",
    d: "M11.615 6.816c.067.125.179.212.271.316.02.022.04.042.041.074-.003.03.003.067-.012.087-.03.037-.028.106-.097.105-.062 0-.032-.075-.078-.095-.031.015.01.081-.048.08-.017 0-.037 0-.043-.02-.01-.04-.026-.095.013-.12.1-.066.077-.114-.011-.163-.038-.02-.043-.055-.03-.09.02-.047.013-.088-.029-.113-.04-.024-.066.01-.097.037-.08.07-.282.084-.348.032-.013-.041.015-.057.043-.073.061-.002.11-.036.16-.063-.039-.003-.06.05-.103.035-.013-.015-.018-.033-.017-.052.01-.055.048-.087.088-.12.048-.027.089-.071.152-.057.011.005.021.011.03.021.024.069.105.1.115.179",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F9F6",
    d: "M14.632 3.277c.026.044.06.081.101.111.082.081.181.101.295.098.25-.008.5-.002.75-.003.042-.003.083-.012.126-.012.021.004.039.012.033.039-.024.044.02.13-.078.13-.028-.025-.054-.05-.078-.078h-.818c-.043 0-.091-.01-.126.018-.07.057-.107.038-.124-.044-.007-.045-.018-.086-.078-.079-.053-.096-.108-.192-.157-.29-.037-.076-.088-.058-.13-.018-.045.042-.09.075-.151.089-.026.006-.05.052-.074.008-.013-.023-.014-.062-.004-.087.025-.064.038-.01.054.01.04-.05.097-.077.168-.103-.057-.058-.124.026-.15-.042-.02-.054-.04-.11.002-.165.033.003.06.022.09.032.031.016.06.034.066.072.029.054.073.095.12.133.079.039.128.104.163.18",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F70B7",
    d: "M26.247 4.941c0-.033-.021-.055-.036-.081-.021-.035-.03-.08 0-.109.029-.027.05.015.073.031.058.043.06.005.068-.04.016-.113-.16-.216-.289-.217h-1.064v-.023h1.371l.002-.03h-.177c-.008-.005-.011-.01-.008-.017.002-.006.005-.008.008-.008.07-.012.145.027.209-.027.074-.006.15-.024.216.028.012.105-.04.193-.09.277-.043.073-.082.15-.125.223-.028.021-.061.035-.093.05-.036.01-.053-.01-.063-.04l-.002-.017z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9F3F6",
    d: "M16.588 5.957l-.028-.001c-.036-.057-.002-.11.016-.16.083-.241.057-.476-.02-.713-.112-.343-.583-.65-.964-.626-.645.003-1.29-.006-1.934.005-.036.004-.062-.013-.086-.038l-.008-.005c.01-.062.07-.063.102-.055.247.065.497.022.746.027.394.01.788.006 1.182.001.122-.001.24.018.36.032.109.012.176.113.276.139.12.03.153.188.29.19.009 0 .024.035.024.053-.002.123.068.217.122.317.076.099.09.203.027.313.037.188-.025.356-.105.52",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F9F6",
    d: "M26.39 4.945c.083-.163.174-.322.23-.497.043.107-.027.209-.018.315 0 .012-.021.035-.034.036-.134.01-.1.122-.133.199h.034c.044-.006.106-.084.116-.042.013.057.057.13-.005.203-.1.115-.192.226-.37.179.081-.031.13-.1.196-.15.023-.016.062-.03.026-.067-.027-.028-.044-.006-.062.016-.045.056-.107.069-.175.065-.034-.04-.08-.026-.122-.026h-1.142c-.07 0-.137.005-.194.052-.017.015-.036.015-.055.004-.012-.02-.012-.038.003-.055l.002-.001c.135-.076.282-.062.428-.063.381-.004.763.009 1.143-.007.02-.009.032-.024.043-.042.032-.038.034-.099.09-.12",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFCFA",
    d: "M6.538 4.264c0-.004 0-.01.002-.012.038-.04-.023-.125.033-.132.07-.01.028.073.049.11.03.056.084.033.128.033.788.002 1.577.002 2.366.002.036.033.064.071.054.125-.025.026-.053.022-.082.01-.071-.037-.147-.046-.226-.046-.672.002-1.344.001-2.016.001-.06 0-.122-.005-.175.035-.028.017-.053.015-.072-.015-.014-.04-.04-.074-.061-.11",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECF4F6",
    d: "M1.44.855c-.04.03.001.067-.006.1-.051.098-.1.196-.138.3-.016.043-.022.093-.072.115l-.073.162c.008.067-.03.116-.063.168-.028.087-.049.179-.124.242-.209.43-.411.864-.597 1.304l-.007.011-.013-.002-.008-.008c-.02-.129.042-.25.107-.333.108-.139.135-.306.21-.454.098-.192.18-.392.277-.585.124-.244.26-.484.311-.759.008-.043.071-.053.06-.105.05-.09.037-.219.163-.26.025.043.015.078-.027.104",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEEF3",
    d: "M8.673 3.51l-.034-.004c.001-.442.004-.885.004-1.327.001-.568-.001-1.136.003-1.705 0-.09-.023-.118-.116-.116-.403.006-.806.005-1.21.007-.043.066-.065.141-.087.217-.05.034-.01.13-.097.14-.013-.114.062-.209.068-.321.002-.05.074-.066.128-.067h1.262c.065 0 .088.025.087.094-.01.95-.016 1.899.001 2.849.002.077-.006.155-.01.232",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAF8",
    d: "M15.937 3.327c-.034-.046-.054-.093-.053-.155.002-.762 0-1.525.002-2.288 0-.03-.016-.07.031-.095.033.043.02.091.02.135 0 .728.001 1.456-.002 2.185 0 .08.013.151.054.218-.017.016-.035.014-.052 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF6F6",
    d: "M10.86 4.63c.053.046.11.084.148.152.054.097.126-.002.19.003-.003.057-.032.095-.082.116.073.08.182.125.217.237.068-.04.01-.08 0-.138.06.046.13.02.178.072.058.063.092.01.13-.027.021-.01.025-.03.026-.052.064-.004.098-.05.126-.098.029-.05.066-.062.118-.054.006.063-.035.106-.073.144-.099.097-.18.209-.28.303-.021.021-.043.043-.067.06-.056.036-.087 0-.118-.04-.049-.06-.107-.112-.162-.168-.038-.042-.072-.089-.112-.13-.067-.08-.143-.152-.204-.237-.024-.028-.049-.055-.055-.093 0-.02.005-.037.02-.05",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7F3",
    d: "M5.946 3.012l.197.473c.221-.002.443-.002.664-.001.066 0 .123-.003.123-.09.02-.06.02-.134.106-.149.015.028.015.056-.003.082-.02.057-.032.118-.062.169-.035.06-.08.088-.168.077-.179-.021-.361-.009-.543-.012-.033 0-.043.015-.05.043-.006.024-.038.04-.048.02-.04-.074-.098-.125-.164-.173-.015-.011-.021-.058.01-.08.014-.01.043-.018.031-.032-.063-.073-.075-.197-.125-.238-.086-.073-.133-.136-.131-.243v-.182c.043-.012.051.024.069.049.01.03.022.058.026.088.007.072.027.14.068.2",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3F1F5",
    d: "M3.154 3.38c.022-.013.025-.035.027-.057l.077.135c.014.006.02.016.017.03.064.041.135.02.202.02.212.004.423.002.635.002.145 0 .146 0 .088-.126l-.513-1.12c-.016-.034-.027-.072-.04-.108.009-.01.018-.01.028 0 .137.173.168.397.27.587.019.034.027.073.067.09.099.08.096.213.161.312.046.07.071.154.1.234.04.09.029.157-.086.156-.254-.003-.506.013-.759.023-.122.005-.241-.03-.274-.179",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F7F5",
    d: "M23.771 5.805c.077.22.234.357.447.436.112.022.225.038.331.083l.058.022c.008.006.011.011.009.018-.003.006-.006.009-.009.009-.137.074-.237-.03-.356-.064-.135-.038-.243-.169-.406-.12-.045.012-.107.017-.134-.048-.023-.056-.026-.11.022-.156.031-.03.042-.058.011-.1-.08-.111-.083-.24-.072-.371.01-.008.021-.007.031 0 .015.02.02.043.022.066.004.022.008.044.015.065.009.048.027.094.032.144l-.001.016",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F9F8",
    d: "M7.21 2.778c.036-.144.092-.281.157-.415.069-.105.09-.229.131-.345-.002-.007 0-.013.005-.019.08.02.065.101.043.125-.098.107-.047.244-.084.364-.04.13-.088.273-.06.438-.107-.044-.157-.099-.108-.225l-.085.077",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#276DB4",
    d: "M27.289 6.087c-.005-.022-.03-.055.024-.04.074.02.094.097.149.137.124.09.27.106.414.11.298.005.596 0 .893.001.106 0 .206.02.268.122.017.027.019.047-.01.063-.009.008-.016.007-.02-.003-.066-.1-.162-.131-.278-.133-.338-.006-.677.023-1.014-.02-.133-.016-.262-.05-.378-.124-.006-.009-.01-.018-.01-.03.01-.031-.013-.049-.03-.068-.004-.005-.006-.01-.008-.015",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9F7",
    d: "M19.687 6.22l.122-.085c.029-.009.058-.013.085.004.046.035.096.068 0 .104-.087.034-.038.068.007.085.03.01.05.015.037.047-.012.026-.04.003-.056.008-.06.016-.116-.095-.178-.007.007.009.011.018.018.02.034.013.079-.015.106.026.004.006-.003.029-.01.033-.053.029-.107.062-.17.038-.075-.028-.148-.062-.222-.094-.01-.01-.013-.021-.012-.034.084-.062.175-.11.273-.146",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F9F6",
    d: "M22.913 1.558c-.01-.039-.02-.077-.05-.107-.07-.086-.123-.183-.154-.291-.002-.142-.105-.247-.135-.378-.009-.012-.007-.022.003-.032.086.015.073.099.1.152.06.116.132.226.17.355.017.06.01.15.13.132.046-.007.045.074.063.116.014.036.003.04-.042.051-.058.014 0 .045.02.069.058.07.145.133.079.244-.01.01-.022.014-.036.012-.078-.094-.124-.204-.148-.323",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F8F6",
    d: "M14.947 2.494c-.119-.109-.119-.109.035-.16.048-.015.095-.033.143-.05.027-.013.055-.021.083.001l.088.068c-.016.047-.062.027-.091.048.028.029.096.03.065.098-.034.077-.086.025-.145.024.031.062.038.129.083.18l-.013.012c-.018.007-.036.007-.053 0-.017-.01-.028-.023-.034-.041-.027-.084-.108-.12-.161-.18",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFDF5",
    d: "M28.773 5.254l-.638-.001c-.04 0-.104.012-.1-.049.004-.049.066-.03.1-.027.422.053.847.013 1.271.023.077.002.133.031.176.09.015.02.011.042-.012.055-.02.01-.036-.003-.04-.02-.02-.085-.086-.071-.146-.071h-.611",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBEDF4",
    d: "M29.633 4.865c.07-.096.112-.206.155-.315-.006-.006-.01-.013-.009-.02 0-.008 0-.012.002-.012.011-.061-.03-.07-.075-.071-.05-.002-.1 0-.15 0-.505-.007-1.008.014-1.511-.011-.026-.002-.05.01-.077.01l-.135.001c-.061.003-.114.062-.18.028l.001-.01c-.016-.014-.017-.03 0-.044h.025c.055-.053.113-.08.183-.028h1.88c.07 0 .15-.015.177.08-.031.077-.069.15-.131.208-.079.05-.04.184-.152.209-.007-.005-.01-.01-.008-.016.001-.006.003-.01.005-.01",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016AB4",
    d: "M27.914 5.151c-.03-.01-.072-.03-.012-.048.068-.022.144-.03.216-.03.434-.003.868-.002 1.302-.001.037 0 .08-.011.108.027-.034.052-.086.026-.13.026-.4.002-.801.002-1.202 0-.095 0-.189.005-.282.026",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5F5",
    d: "M19.842 3.015c.08.025.026.118.08.157v.024c-.029.065-.124.074-.132.157-.093-.02-.215-.005-.194-.161l-.049.003.036-.102c.024-.03.01-.08.053-.102l.028-.026c.04.083.12.03.178.05",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F5F7",
    d: "M9.296.36c0 .935.002 1.869.001 2.803 0 .107-.04.212-.026.32h-.025c.054-.977.012-1.955.029-2.933 0-.061-.053-.135.021-.19",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF6F3",
    d: "M15.652 1.69c.095-.283.078-.556-.077-.815-.008-.004-.011-.009-.01-.014.003-.006.005-.01.007-.01.01-.007.018-.015.026-.023.015.003.024.012.027.026.159.188.113.408.113.626 0 .122-.087.259.036.374.007.007-.057.053-.053.1-.067-.004-.058-.061-.075-.12-.034.074-.114.128.017.18-.065-.005-.113.051-.17.01.022-.098.12-.156.13-.26-.01-.032.004-.055.03-.075",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAF3F3",
    d: "M19.27 3.537c-.17.043-.35.05-.509.01-.11-.026-.228-.05-.338-.088-.153-.054-.294-.13-.433-.213-.05-.03-.028-.097-.075-.126.009-.009.02-.014.033-.015.095.033.163.111.251.155.15.085.31.14.475.185.195.033.39.045.588.04.045-.002.094-.015.136.02-.024.084-.082.034-.128.032",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F9F8",
    d: "M7.033 3.327l-.003-.082c-.02-.024-.02-.047.008-.066l.173-.402c0 .04.023.068.046.1.066.093.04.293-.039.367-.06.056-.088-.018-.142-.032-.01.04.001.09-.043.115",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFDF5",
    d: "M26.195 5.202c-.016.079-.08.05-.126.05-.314.003-.628.005-.942 0-.1-.002-.184.008-.234.106-.028.014-.042-.003-.052-.026.021-.02.064-.05.06-.06-.037-.1.037-.07.078-.07h1.216",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF6F7",
    d: "M26.902 5.59c.062.184.106.378.281.498.039.012.071.028.054.078-.1.021-.142-.065-.177-.122-.043-.07-.117-.118-.136-.202-.002-.012-.01-.032-.024-.021-.114.1-.113-.056-.118-.074-.017-.063-.054-.149.034-.193.058-.028.005-.095.055-.119.037.046-.012.11.03.155",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0667B0",
    d: "M29.319 5.696c-.073.07-.15.006-.218-.005-.136-.021-.27-.02-.407-.02-.24.018-.482.024-.723.022-.04 0-.079-.013-.103-.047-.011-.017.001-.03.023-.03.4.023.802-.012 1.203.025.076.007.154.019.225.055",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F5F7",
    d: "M9.324 3.536h2.586c.041 0 .088-.014.122.026l-2.56-.001c-.05 0-.105.019-.148-.025",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAF4",
    d: "M16.145 6.477c.002-.054.05-.075.085-.089.109-.045.188-.118.24-.222.02-.04.048-.058.092-.053-.043.124-.007.268-.104.38-.028.033-.073.05-.082.023-.042-.118-.11-.065-.18-.04-.014.005-.034.001-.05.001",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#236FB7",
    d: "M27.891 5.616c.038.06.099.054.157.054h.646c-.021.029-.052.025-.082.026-.231.008-.462.02-.693.021-.045 0-.119.13-.153-.031-.013-.062-.052-.128-.06-.198.026-.024.018-.072.06-.085.07.035.05.133.119.17l.006.043",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAF8",
    d: "M17.03.333h-.885c.03-.063.083-.08.15-.079.203.003.407.002.611.001.058 0 .117-.002.125.078",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F0F6",
    d: "M17.532 1.507c-.046.36-.059.72.068 1.069.013.035.032.069.048.103.03.016.042.04.036.074.032.092.083.17.153.237l.009.016-.013.013c-.09-.026-.11-.103-.155-.175-.162-.269-.225-.562-.219-.864.004-.156-.028-.328.073-.473",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0070B8",
    d: "M4.455.438v2.42c-.009.012-.018.013-.027.001l-.006-1.8c0-.208.004-.415.005-.622.01-.01.02-.009.028 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCE8F1",
    d: "M22.654 3.197v-.052c.058.048.05.133.104.183.05.138.152.168.291.159.202-.013.404-.004.607-.003.075 0 .11-.023.062-.1-.02-.07-.1-.126-.05-.212.099.062.122.174.158.27.043.11-.07.105-.127.101-.104-.008-.208-.005-.311-.006-.161-.003-.322-.005-.482.001-.082.003-.13-.023-.158-.1-.028-.081-.062-.16-.094-.24",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0070B8",
    d: "M17.213 4.447V4.42c.63 0 1.26-.001 1.89.001.077 0 .156.012.227.048-.072.022-.144.045-.217.004h-.026c-.06-.047-.121.036-.182 0-.045-.026-.093-.013-.14-.013l-1.412-.001c-.047 0-.095.012-.14-.012",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF6F6",
    d: "M6.203 1.426L6.1 1.19c-.048-.07-.087-.143-.086-.23-.031-.111-.07-.219-.122-.322-.038-.022-.035-.059-.034-.095L5.8.363c.138.046.149.177.16.285.016.176.121.317.174.477.01.028.025.078.04.116.024.059.035.123.05.185-.007.013-.014.013-.022 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCE8F1",
    d: "M24.918 1.635c-.092.04-.035.121-.049.183v.052c.025.142.009.284.01.426.003.298 0 .597.001.895 0 .069-.006.136.023.204.021.049.016.105-.058.117l-.007-.006c-.024-.064 0-.13-.011-.194.005-.525 0-1.05.002-1.574 0-.034-.01-.07.008-.102l.01-.1c.022-.007.034.003.04.025l.031.074",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#106FB5",
    d: "M23.667 3.172l.056.204c.007.007.009.014.006.02-.003.007-.006.01-.008.01-.037-.056-.092-.054-.15-.053-.218.001-.436 0-.655-.021h.744c-.061-.07-.04-.15-.076-.215-.058.017-.024.1-.133.126.16-.134 0-.262.06-.384l.156.313",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F9F6",
    d: "M24.845 3.512c.025-.018.048-.038.045-.073-.05-.523-.01-1.046-.021-1.57.04.04.023.09.024.136 0 .378.01.755-.005 1.132-.006.127.087.235.043.363-.007.022.033.064-.012.074-.021.005-.051-.024-.077-.038l.003-.024",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 7) translate(29.659 4.357)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wmnnmt90cf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u2iz6nfu3e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F9F3",
    d: "M.166.324C.184.236.258.176.333.116c.038.051.055.112.021.162C.28.39.285.507.297.626.301.66.313.707.262.717.196.73.187.674.176.642.155.579.156.513.2.453.237.402.248.355.166.323",
    mask: "url(#wmnnmt90cf)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFBF4",
    d: "M25.674 6.711c-.014.035-.04.052-.078.053-.048-.002-.095 0-.039-.067.048-.056.006-.115.003-.173-.006-.13-.09-.058-.134-.07-.039-.01-.055-.015-.038-.055.014-.017.033-.023.053-.025h.118c.071.01.126.065.197.073h.001c.007.01.01.02.008.033-.025.033-.02.07-.01.106-.05.027-.05.086-.08.125",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAF0",
    d: "M4.273 3.38c-.13-.163-.19-.357-.26-.547l.033-.06c.076.113.097.248.208.342.06.051.012.174.019.264",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEEF5",
    d: "M22.263.365c-.316-.002-.631-.003-.947-.007-.06 0-.095.018-.116.076-.02.057-.039.115-.08.16.012-.236.036-.26.26-.26l.93-.001c.075 0 .142.002.137.105.014.013.015.03.007.047-.008.01-.018.012-.03.01-.037-.038-.051-.09-.082-.13h-.052c-.009.007-.018.007-.027 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F9F6",
    d: "M23.956 7.623c.038-.043.09-.026.135-.026h1.583c-.038.042-.088.025-.134.025-.426.001-.853.002-1.28 0-.101 0-.203.036-.304 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6FAF3",
    d: "M9.168 4.369c-.034-.027-.048-.063-.052-.104.115-.07.247.013.365-.04.054-.024.08.048.13.04-.01.066-.063.057-.109.06-.104.009-.21-.002-.308.044-.009.008-.018.008-.026 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDF8EF",
    d: "M7.736 1.922V3.3c-.02-.002-.067.035-.056 0 .066-.208.02-.42.027-.628.005-.193.023-.388-.022-.58-.014-.064.002-.129.026-.19 0-.003.004-.005.007-.008l.018.027z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F8F6",
    d: "M15.208 2.702c.108-.007.045-.14.139-.172.04.094-.02.193.007.288.008.03.01.07.035.07.12.003.068.09.08.146-.007.012-.017.016-.03.012-.085-.077-.154-.167-.224-.256-.012-.028-.025-.057-.007-.087z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 7) translate(29.659 5.918)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tnq0blpumh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7x0z1bb4gg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E0EEF4",
    d: "M.166 1.21L.13 1.21c.1-.157.203-.313.196-.495C.312.663.31.612.328.56.34.389.26.239.158.093.346.158.353.3.36.426c.01.192.047.39-.059.576.025.026.028.052-.002.077-.068.03-.088.088-.133.131",
    mask: "url(#tnq0blpumh)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F7FAF3",
    d: "M3.149 1.064C3.1.992 3.064.915 3.042.831l.077.052c.046-.032.02-.14.094-.118.085.025.017.106.01.155-.006.043-.003.07.013.108.017.042.066.085.021.139-.102.036-.052-.09-.108-.103",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5F5",
    d: "M19.79 3.536h.816c.041 0 .088-.014.122.026-.044.024-.086.02-.136.013-.205-.029-.411-.014-.617-.006-.027 0-.125-.006-.065.086.01.015-.012.035-.028.027-.03-.014-.072.028-.09-.024-.013-.04-.033-.08-.002-.122",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF5F6",
    d: "M15.937 3.327h.052c0 .022.005.041.026.052v.052c-.034.019.006.11-.078.079l-.03-.026c-.022.012-.037-.001-.054-.013-.01-.011-.018-.024-.018-.04-.008-.028-.027-.045-.052-.055-.104-.058-.184-.137-.222-.252.081-.012.133.008.162.097.017.05.072.088.11.132.046.036.073 0 .104-.026z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F4F4",
    d: "M19.895 6.139c-.03.02-.058.012-.086-.004.075-.092.155-.18.193-.297.022-.09.067-.176.062-.273 0-.068.016-.135.018-.203.005-.014.013-.024.026-.032.03.239.04.473-.138.668-.038.04-.054.092-.075.14",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8F0F3",
    d: "M26.902 5.59c-.055-.043-.019-.104-.031-.155v-.077c-.019-.081-.027-.162.027-.235.036-.227.158-.392.365-.492l-.082.09c-.046.077-.095.152-.16.215h.002c-.013.058-.037.113-.074.16-.077.159-.047.328-.047.494",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBF2",
    d: "M16.692 5.436c.005-.105-.002-.21-.026-.313.005-.02.002-.049.015-.058.028-.02.033.01.039.03.02.06.05.118.05.184 0 .036.004.066.048.079.088.025.051.086.035.151-.017-.126-.115-.031-.16-.073",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2268B2",
    d: "M4.455.438h-.028l.001-.053h1.324c-.431.05-.866-.008-1.297.053",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F9F6",
    d: "M23.197 2.157l-.049-.08c-.008-.01-.015-.02-.02-.032-.007-.05-.043-.099-.005-.15.068-.057.1-.135.117-.24.062.077.06.17.03.203-.102.111-.038.216-.017.324-.03.016-.039-.014-.056-.025",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F9F3",
    d: "M1.47.755c-.105.052-.073.194-.165.256-.037-.004-.068-.042-.044-.057.102-.063.068-.199.156-.265.023-.018.04-.045.036-.08-.013-.103.048-.088.111-.067-.008.07-.03.137-.062.2-.008.01-.019.015-.032.013",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0170B4",
    d: "M18.46 6.716c.045-.054.069-.004.09.022.074.091.134.198.261.23-.025.11.093.139.121.218.002.003-.019.014-.03.021-.046.01-.055-.027-.07-.057-.042-.054-.104-.09-.134-.155l-.238-.28",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F8F1",
    d: "M23.685 5.514h-.013c.003-.06-.001-.124-.069-.143-.084-.024-.038-.078-.038-.122 0-.06.017-.078.077-.045.027.015.026-.022.027-.04.007-.067.032-.124.081-.17-.007.175.012.353-.065.52",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1973BA",
    d: "M23.983.49c-.024-.1.01-.135.118-.132.332.01.664.007.996.01l.01.042C24.767.37 24.43.38 24.09.4c-.077.005-.077.054-.108.089",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E71B6",
    d: "M18.283.522c.136-.034.26-.111.404-.113.021-.009.042-.015.062.005-.04.022-.082.043-.076.099.006.062-.036.075-.068.044-.08-.078-.155-.037-.232-.008-.033.012-.065.031-.093-.007.002-.007.003-.013.003-.02",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0572B5",
    d: "M7.136.722l.077-.159c.027.027.02.055.002.083.045.075-.036.112-.054.168-.04.126-.091.248-.14.371-.008.024-.023.072-.043.004l.158-.467",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F8F4",
    d: "M27.653 4.42l.001.045-.154.036c-.023-.052-.023-.052.077-.063-.022-.041-.057-.043-.096-.038-.044.007-.036-.028-.035-.05 0-.03-.01-.063.029-.079.041-.016.155.059.162.105.002.015.01.03.016.045",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7FAF6",
    d: "M12.214 7.518c.03.02.025.05.026.079-.03.005-.077-.01-.066.049.004.021.015.042.012.062-.005.048.026.105-.03.14-.009.006-.038 0-.044-.01-.035-.05-.067-.121-.04-.165.035-.057.062-.134.142-.155",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8F3F4",
    d: "M20.108 5.33l-.008.034c-.053-.015-.036-.05-.025-.083.006-.07-.006-.134-.044-.193-.046-.059-.065-.13-.088-.198l-.083-.127c.04-.02.077-.04.093.029.02.084.114.133.108.23 0 .008.027.016.042.024.035.069.05.138.002.208l.003.076z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116FB6",
    d: "M23.685 5.514c-.006-.177.014-.35.065-.52.026-.008.022-.031.024-.051.012-.017.021-.037.047-.036.017.005.022.022.03.034-.005.064-.087.106-.051.182-.012.136-.064.267-.034.407.007.033-.02.066-.065.061l-.016-.077",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6EBF4",
    d: "M24.607 6.373v-.027c.313-.001.626-.004.94-.001.075 0 .155.005.202.081-.075.035-.126-.045-.195-.04h-.133c-.14-.008-.283.015-.423-.012l-.39-.001",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF4F4",
    d: "M20.748 1.444l-.097.17c.02-.097-.05-.216.092-.284.038-.019.043-.107.063-.163.004-.036.026-.058.052-.079.02-.01.025-.03.026-.052.013-.008.024-.007.034.004-.009.155-.091.279-.17.404",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F8EA",
    d: "M24.685 5.227h.052c-.001.077-.113.145-.018.231.006.005.008.087-.06.056-.067.017-.05-.056-.083-.076h.001c-.028-.067.01-.125.028-.186.022-.022.04-.056.08-.025",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F8F6",
    d: "M13.594 7.597c.173.016.35-.034.52.026h-.269c-.069 0-.15-.024-.154.094-.001.044-.051.041-.082.026-.028-.014-.067-.03-.044-.077.011-.022.02-.046.029-.07",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F7F4",
    d: "M20.917 1.039l-.033-.003c-.127-.047-.049-.158-.071-.238-.005-.016.018-.04.043-.04.032.002.042.02.036.053-.011.056-.007.1.07.07.015.017.014.036.002.055l.003.024c0 .037-.003.072-.05.079",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAF3",
    d: "M27.237 3.562c.067-.042.164-.068.104-.183.004-.02.002-.05.015-.058.034-.02.036.02.051.036.063.07-.018.157.027.23.008.015-.028.031-.036.02-.043-.06-.121.015-.161-.045",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAF2",
    d: "M28.877 6.712c-.001.033-.019.05-.052.052-.042.017-.084.033-.13.025-.03-.076.087-.141.016-.224-.007-.008.022-.033.046-.033.034 0 .072.027.058.05-.052.084.019.098.062.13",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8F2F4",
    d: "M3.149 1.064c.08-.011.034.109.108.103.006.105.049.2.108.28.038.05.035.089.021.137-.091-.167-.173-.34-.237-.52",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#176EB3",
    d: "M15.561 3.124l.222.252c-.029.037-.058.036-.082-.003-.076-.127-.201-.212-.285-.332.01-.01.02-.011.032-.003.007 0 .014 0 .02-.003l.093.089",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEDF5",
    d: "M5.578 2.044l.021.01c.024.02.042.042.028.076 0 .022.003.043.022.057.03.027.036.06.033.097l.104.313c-.053-.028-.046-.107-.107-.129-.03-.03-.046-.062-.026-.104-.016-.109-.09-.203-.075-.32",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5F5",
    d: "M19.27 3.537c.042-.011.097.023.126-.036-.033-.053-.008-.088.035-.117.013-.028.016-.064.05-.08l.047-.058c.035.123-.058.214-.093.316-.014.04-.113.015-.165-.025",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8F2F4",
    d: "M3.675 2.155l-.028.001-.078-.13c-.045-.046-.057-.106-.075-.164l-.059-.173c.108.142.199.291.24.466",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0062AC",
    d: "M5.236 3.43c-.014.05-.014.052-.07.053h-.735l-.003-.026c.009-.012.018-.012.027 0l.658.001c.043 0 .085-.004.123-.027",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFAEF",
    d: "M6.278 1.505c.01-.023.014-.051.03-.068.026-.026.029-.101.084-.066.038.024 0 .065-.022.097-.04.058.016.137-.04.193-.05.01-.049-.034-.062-.061-.002-.032-.02-.066.01-.095",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1870B3",
    d: "M15.572.852l.004.023c-.047.036-.057-.013-.074-.035-.062-.08-.12-.163-.222-.2-.052-.02-.036-.048.002-.07.127.062.215.165.29.282",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#156EB7",
    d: "M17.035 7.519h.023c.219.029.439.005.658.013.055.002.112-.008.167.007l.008.008c-.273.04-.548.008-.822.015-.025.001-.037-.018-.034-.043",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFBF1",
    d: "M5.653 2.364c.018.032.03.066.026.104-.046.017-.002.111-.075.095-.05-.012-.058-.069-.054-.116.006-.058.022-.113.103-.083",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#156BAF",
    d: "M18.195.59c.035.066-.037.058-.06.08-.057.062-.158.08-.158.196 0 .061-.063-.031-.087.014-.016-.001-.018-.016-.026-.026.093-.11.2-.201.33-.264",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7FAF3",
    d: "M13.385 4.369h-.078c.02-.066.091-.081.127-.133.022-.034.07-.033.103-.007.018.014.041.048.036.062-.016.04-.057.042-.095.032-.046-.012-.073.006-.093.046",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#206CB4",
    d: "M4.455 3.456h-.027c-.01-.198-.012-.397 0-.597h.027c.004.132-.01.264.024.396.017.067-.004.135-.024.201",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1EFF5",
    d: "M23.197 2.157l.056.025c.052.16.163.3.18.474-.095-.159-.162-.33-.236-.499",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F9F6",
    d: "M23.774 7.596c.02.011.09-.025.045.047-.025.041-.003.053.033.058-.012.07-.065.054-.107.045-.038-.009-.047-.043-.05-.08-.003-.057.03-.072.079-.07",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#226DB5",
    d: "M19.113 4.473l.217-.004c.054.004.104.02.15.05-.005.024-.012.063-.043.044-.098-.06-.201-.05-.307-.039-.077.009-.034-.027-.017-.051",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5E9F3",
    d: "M11.198 6.894c-.024.01-.042.027-.05.052l-.106.13c-.047.011-.05.09-.114.074-.018-.081.056-.11.09-.16.026-.03.046-.065.073-.094.007-.01.015-.017.023-.025.025-.022.048-.047.073-.069.02-.013.038-.026.063-.015v.055c-.004.03-.034.034-.052.052",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2E8F2",
    d: "M27.885 5.572c-.09-.022-.096-.104-.123-.171-.046-.056-.04-.103.026-.137l.046-.04.002.057c.032.057-.03.126.025.18l.024.111",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDF9F0",
    d: "M26.351 5.722c-.05-.005-.07-.05-.104-.078.024-.023-.005-.088.062-.077.043.007.072.032.087.07.015.04.012.079-.045.085",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1F0F5",
    d: "M25.157.484L25.146.44c.139.072.198.2.238.34l-.05-.029c-.061 0-.045-.045-.047-.08-.035-.068-.075-.133-.13-.187",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F9F6",
    d: "M23.262 1.594l-.082-.075c-.024-.023-.038-.049-.02-.08.008-.012.025-.026.039-.028.035-.003.056.025.067.051.018.043.026.09-.004.132",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAF0",
    d: "M13.281 7.623c.046-.003.09 0 .13.026.035.063.018.1-.055.103-.105.004-.066-.077-.075-.13",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F8F4",
    d: "M27.862 4.393c-.063-.006-.123.012-.183.027.039-.189.165-.07.28-.079l-.097.052",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7EAF5",
    d: "M13.906 2.547l-.024-.083.1.087c.05.029.103.057.11.124.015.02.031.038.047.057.018.002.028.013.034.029.002.011-.003.02-.013.025-.12-.043-.152-.178-.254-.24",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7F3",
    d: "M5.855 3.19c.078.155.067.194-.073.26.05-.083.06-.165.073-.26",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCF9EF",
    d: "M10.313 2.728c-.055.046-.067-.003-.075-.04-.007-.037-.002-.077-.003-.116.034-.027.075-.084.078.019v.137",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8F3F4",
    d: "M19.687 4.628c-.02-.026-.048-.041-.08-.05-.026.006-.033-.004-.024-.028.064-.007.125.01.184.031.068.025.065.064.02.11-.055.013-.085-.013-.1-.063",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFBF0",
    d: "M28.28 5.535c-.09.042-.18.036-.306.013.123-.053.215-.031.305-.013",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#236EB5",
    d: "M19.687 4.628l.1.063.03.039h-.221c.028-.044.04-.087.09-.102",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7FAF6",
    d: "M12.032 7.31c.053.027.084.068.078.13-.041.037-.068.036-.11-.01-.064-.069.021-.08.032-.12",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEEF5",
    d: "M20.964.936L20.96.88c.028-.109.068-.211.158-.285-.038.12-.088.234-.155.341",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F4F3",
    d: "M12.11 3.51c.083.025.114.06.089.11-.013.025-.005.078-.061.058-.055-.019-.041-.045-.016-.084.011-.018-.007-.056-.012-.084z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF5F6",
    d: "M15.69 3.091c-.057-.05-.124-.061-.114-.14.003-.026.02-.037.045-.027.07.028.07.085.068.167",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F9F6",
    d: "M23.696 6.894c.051.118.082.238.026.364-.01-.097.034-.205-.068-.286-.03-.023.01-.06.042-.078",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6FAF3",
    d: "M6.538 4.264c.05.003.076.029.078.078-.031.024-.054.066-.104.053-.022 0-.04-.005-.052-.026.016-.043.029-.088.078-.105",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0EEF5",
    d: "M6.282 1.605l.048.056.104.313c-.008.012-.016.012-.024 0l-.105-.236c-.026-.03-.045-.064-.04-.107 0-.012.006-.02.017-.026",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1F0F5",
    d: "M25.382.804V.78c.102 0 .137.06.137.152-.01.016-.018.032-.039.034-.045-.046-.09-.093-.098-.162",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDF8EE",
    d: "M23.383 6.946c.004-.046-.01-.094.015-.143.058.013.028.06.037.09v.065c-.002.02.004.053-.026.05-.035-.003-.022-.039-.026-.062",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAEF",
    d: "M23.921 4.667c-.04-.012-.044-.04-.04-.071.003-.04.032-.047.065-.042.027.003.05.016.044.049-.007.037-.034.056-.069.064",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006BAD",
    d: "M17.967 6.452c.06-.056.259-.04.313.025-.009.011-.019.011-.029.001-.09-.045-.19-.005-.284-.026",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F9F6",
    d: "M22.449.488l-.002-.05c.109.018.121.091.103.182-.09-.001-.088-.072-.101-.132",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEEF5",
    d: "M22.449.488c.043.036.041.108.101.132.01.043.018.087.027.13l-.003.032-.067-.113c-.041-.023-.044-.067-.056-.105h.002c-.03-.019-.021-.044-.012-.07l.008-.006z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F9F6",
    d: "M11.641 5.045c-.009.046-.015.105-.066.112-.04.005-.044-.055-.064-.085.049.018.074-.083.13-.027",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F5E9",
    d: "M28.98 6.71l-.025-.024c0-.046-.04-.084-.011-.136.03-.058.042.002.062.005.057.037.029.083.014.127 0 .012-.003.023-.01.033-.01.007-.02.004-.03-.006",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAF9EC",
    d: "M24.841 5.332l.052.026c0 .038.002.08-.043.093-.028.01-.048-.013-.055-.038-.01-.04-.007-.076.046-.081",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F7F5",
    d: "M24.998 6.374h.442c.009.005.011.01.009.016-.003.006-.006.01-.009.01h-.052c-.13-.015-.263.03-.39-.026",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7EBF4",
    d: "M6.613 2.177c-.039.033-.024.097-.08.132-.023-.05-.051-.095-.051-.151l.064.06c.034-.035.025-.095.077-.112.016.026.013.05-.01.071",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7EAF2",
    d: "M15.44 2.046l.025-.005c-.048.097-.122.165-.228.197l-.01-.014c.007-.053.055-.07.086-.103.053-.008.069-.077.127-.075",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCECF5",
    d: "M18.907 7.228c.077.073.159.141.211.235-.088-.05-.151-.127-.213-.205-.013-.01-.012-.02.002-.03",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F8E8",
    d: "M29.633 4.993l.02-.015c.012-.01.031-.025.03.006-.004.051.026.112-.023.152-.021.016-.042-.016-.054-.038-.018-.042-.006-.076.027-.105",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1670B3",
    d: "M27.237 6.166c-.001-.037-.04-.049-.053-.078.034-.049.07.008.105-.001.02.024.068.029.052.077l-.003.036-.101-.034",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6E9F0",
    d: "M29.633 4.993c.002.038-.01.072-.027.105l-.06-.004.036-.126c-.014-.046.01-.057.049-.055l.002.08",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F9EB",
    d: "M14.635 3.457c.002-.016-.001-.045.006-.048.053-.021.049.042.08.059.022.012.06.052-.008.068-.035-.018-.06-.044-.078-.079",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F4F4",
    d: "M20.105 5.254l-.002-.208c.062.068.106.138.002.208",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFAEA",
    d: "M15.625.854l-.026-.026c.055-.106.091-.046.139.02l-.113.006",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBF8EC",
    d: "M26.195 5.644l-.13-.026c.013-.073.066-.055.11-.045.042.009.034.041.02.071",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8F0F3",
    d: "M27.499 4.501l-.235.129c.04-.113.143-.111.235-.129",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F7E6",
    d: "M10.235 2.39c.017-.084.084-.04.13-.052 0 .125-.072.07-.13.052",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBDCEF",
    d: "M29.006 6.71c0-.051.023-.103 0-.155v-.078c.007 0 .014.002.02.003l.029.055c.026.04.026.082 0 .122l-.029.052-.009.008-.01-.006z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116AB1",
    d: "M17.864.854l.026.026c-.011.058-.006.136-.104.079l.078-.105",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEEEF5",
    d: "M1.486.75c-.003-.081.052-.14.078-.208l.033-.023-.03.128c-.011.046-.015.099-.08.102",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF6F6",
    d: "M6.121.732c-.002.026.003.06-.033.058C6.06.79 6.045.762 6.048.734c.001-.027.015-.051.045-.05.03.001.025.029.028.048",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0EEF4",
    d: "M25.672 1.195c-.053-.04-.081-.098-.111-.155.123-.01.1.084.111.155",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F7E2",
    d: "M27.86 5.461c-.092-.049-.032-.118-.024-.18.07.051.012.12.025.18",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074AD",
    d: "M18.251 6.478l.03-.001c.061.034.095.088.107.157-.058-.042-.103-.094-.137-.156",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006CB2",
    d: "M5.36 1.436c.075.028.105.074.056.148l-.055-.148",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D6CB4",
    d: "M29.63 4.913l-.048.055c-.054-.047-.026-.096.007-.135.014-.017.034.013.044.032-.001.008 0 .017.002.025-.004.007-.005.014-.004.023",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBEDF4",
    d: "M23.82 4.907l-.046.036c-.042-.104.055-.116.106-.16l-.03.079c0 .02-.005.04-.03.045",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7FAF6",
    d: "M12.344 7.623c.035-.026.07-.001.104 0-.004.042-.02.078-.07.072-.041-.005-.031-.044-.034-.072",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F4F3",
    d: "M12.165 2.795c-.032-.041-.046-.08 0-.11.006-.005.029 0 .032.008.019.04-.018.068-.032.102",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDEDF3",
    d: "M18.698 6.995c.053.045.106.09.134.155-.052-.045-.157-.045-.134-.155",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A6CAE",
    d: "M2.973.72L2.96.753C2.925.705 2.867.665 2.917.595l.056.125",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF4F4",
    d: "M12.624 3.691c.066-.064.107-.052.165-.036-.05.052-.094.031-.165.036",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFAF0",
    d: "M21.535 6.477c-.022-.013-.05-.025-.04-.056.01-.03.042-.019.066-.022.114.067-.049.042-.026.078",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F7F4",
    d: "M20.858 1.088c0 .038-.018.064-.052.078-.029-.029-.048-.06 0-.087.005-.003.049-.066.052.01",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF6F7",
    d: "M26.898 5.123c-.026.077-.029.156-.027.235-.035-.083-.058-.165.027-.235",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F9F6",
    d: "M25.752 7.597h.13c-.043.083-.086.083-.13 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0EEF5",
    d: "M6.278 1.505l.004.1-.008.008c-.01.007-.017.004-.02-.007l-.05-.18h.022l.052.079",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7EAF5",
    d: "M14.28 2.907c-.041.006-.07-.011-.087-.048-.01-.025-.022-.049-.033-.073l.006-.005c.084 0 .112.052.114.126",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F4F3",
    d: "M12.225 3.39c.02.053.024.092-.023.135-.019-.053-.024-.092.023-.135",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F4F4",
    d: "M20.291 5.156c.024.043.031.077-.011.12-.024-.047-.034-.081.011-.12",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEEEF5",
    d: "M1.677.363c-.025.053-.037.114-.081.157-.002-.067-.02-.143.081-.157",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7EBF4",
    d: "M6.41 1.973h.024c.029.06.066.115.049.186-.041-.056-.059-.12-.073-.186",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F4F4",
    d: "M20.228 5.442c-.028 0-.039-.013-.042-.03-.004-.023 0-.045.028-.049.018-.003.037.004.035.025-.002.02-.014.038-.021.054",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCE2EF",
    d: "M24.576 5.438l.082.076.003.071c-.065-.027-.074-.087-.085-.147",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFAF0",
    d: "M21.483 6.607c.004-.041.018-.077.052-.104.055.07.008.09-.052.104",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5D3EB",
    d: "M5.288 1.403l-.02-.098c.09-.015.044.067.07.098h-.05z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1EFF5",
    d: "M23.123 1.896c.008.052.037.101.026.156-.065-.044-.094-.104-.079-.183h.027l.026.027z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7E9F5",
    d: "M25.882 1.505c-.05-.041-.079-.099-.11-.154.072.026.099.085.11.154",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F5F7",
    d: "M9.197.366c.032.043.027.075-.012.111-.022-.042-.029-.075.012-.111",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFBF4",
    d: "M25.376 6.63c.009-.019.025-.022.042-.02.016.002.038.004.032.028-.004.019-.024.021-.04.02-.017-.003-.036-.004-.034-.029",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 7) translate(29.659 6.699)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "x5wi4dklbj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yjh71tw4mi"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F4E5",
    d: "M.299.383L.3.283C.363.29.374.33.36.379.349.414.322.41.299.383",
    mask: "url(#x5wi4dklbj)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F5F7",
    d: "M9.25 3.47c-.015.067.018.1.056.133-.091-.026-.091-.026-.056-.134",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9E9",
    d: "M15.78 3.562c.05.002.077.028.079.077-.058.006-.084-.02-.078-.077",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F4F3",
    d: "M12.225 2.842c.021.048.002.09-.017.09-.038.002-.016-.035-.013-.054.001-.01.015-.019.03-.036",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006AAE",
    d: "M6.613 2.177l.01-.071.022-.027c.037.048.027.081-.032.098",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F0F6",
    d: "M17.939 3.12h-.024c-.04-.023-.072-.053-.082-.101l.006-.005c.065.005.112.028.1.105",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAF8",
    d: "M15.937 3.327c-.02.068-.05.098-.104.026l.104-.026",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEDF5",
    d: "M5.834 2.73l-.051-.054.002-.08.045.063c.028.022.026.045.004.07",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7E9F5",
    d: "M25.962 1.583l-.003.03c-.01.006-.017.004-.023-.005l-.053-.103c.052 0 .058.046.08.078",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3580C2",
    d: "M24.685 4.423c-.048.042-.106.02-.16.022.05-.03.106-.025.16-.022",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCECF5",
    d: "M19.195 7.543l-.056.002c-.031-.022-.026-.053-.021-.083.007 0 .015 0 .022.002.037.013.063.034.055.079",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDEDF3",
    d: "M18.907 7.228l-.002.03c-.04-.025-.081-.05-.073-.108l.07.058c.003.006.004.013.005.02",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8F2F4",
    d: "M3.436 1.69c-.03-.029-.046-.065-.05-.106.062.014.073.052.05.106",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDF8EF",
    d: "M7.71 1.557c.03.019.025.05.026.078l-.004.048-.022.003v-.129z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F8F4",
    d: "M10.99 7.336c.023.017.06.027.035.066-.005.007-.028.01-.034.005-.025-.021.005-.047 0-.07z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F9F6",
    d: "M23.722 7.388c.035.046.047.086-.026.104l.026-.104z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAF4E2",
    d: "M18.018 6.54c-.004.015-.008.03-.024.02-.008-.005-.016-.018-.017-.028-.001-.014.01-.025.024-.018.008.005.012.018.017.025",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2269AB",
    d: "M19.583 4.55l.024.029c-.017.022-.04.032-.062.011-.015-.013-.005-.029.01-.04h.028",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116AB1",
    d: "M17.753 1.007c.027.014.038.037.013.056-.03.023-.028-.01-.032-.026l.02-.03",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C7EA4",
    d: "M2.837.413c-.038-.007-.073-.02-.1-.05.047-.01.09-.01.1.05",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F8F4",
    d: "M11.124 7.152v-.098c.006-.001.01-.003.011-.002.018.037.019.072-.011.1",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0EEF4",
    d: "M25.493.954l.025-.022c.02.025.055.044.024.083l-.044-.04c-.01-.003-.014-.007-.012-.012.002-.006.004-.01.007-.01",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5F5",
    d: "M19.79 3.43l-.026.08c-.029-.021-.032-.05-.018-.079.002-.006.028 0 .044 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F9F6",
    d: "M24.034 6.79c-.043.038-.087.038-.13 0h.13z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7F0F4",
    d: "M10.271 1.415c.038-.017.069-.022.079.003.012.029-.016.015-.028.013s-.023-.007-.05-.016",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7EAF2",
    d: "M15.208 2.285l-.083-.001.03-.03c.021-.02.04-.047.074-.026l.008.01-.03.047",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0EEF4",
    d: "M25.725 1.275c-.028-.02-.049-.045-.053-.08.058 0 .055.04.053.08",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2571B8",
    d: "M8.439 3.457c-.148-.146-.338-.094-.516-.13h.14c.047 0 .095.002.142 0 .042-.003.088.014.124-.022.047-.047.077-.026.094.026.008.025.007.05.045.047.041-.003.052-.032.053-.062.002-.051-.004-.103-.004-.154 0-.81 0-1.62.002-2.43 0-.046-.04-.137.076-.112.024.045.012.093.012.14v2.604c.001.072-.055.083-.107.099-.021.007-.042.012-.061-.006",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#066AB4",
    d: "M8.595 3.405V.62.542C8.56.49 8.56.438 8.595.386c.028.021.025.053.025.083l-.003 2.989c-.01.008-.021.007-.03-.003-.008-.018-.007-.035.008-.05",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#226FB6",
    d: "M7.038 3.18l-.008.065-.07.136c-.029.005-.009.068-.057.05-.036-.107.02-.227-.05-.333-.015-.022.007-.112.055-.12.064-.013.057.044.058.095 0 .04.003.102.072.106",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066AC",
    d: "M7.79 3.276V1.922c.008-.012.016-.012.023 0v1.354c-.008.011-.015.01-.022 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#196EAA",
    d: "M6.903 3.431l.058-.05c-.006.102-.058.136-.16.131-.184-.008-.368-.001-.552-.003-.036 0-.078.016-.106-.024l.033-.004c.196-.022.393-.003.589-.01.046-.003.094.014.137-.016v-.024",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2168B2",
    d: "M8.307.405h-.825v-.01h.825v.01",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296DB4",
    d: "M7.215.646c0-.028 0-.055-.002-.083.032-.068.018-.16.107-.198.047.057.047.056-.015.095-.011.007-.024.035-.02.042.066.092-.037.101-.07.144",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0062AC",
    d: "M8.594 3.456l.023.002c-.06.049-.131.022-.197.023-.192.004-.385.001-.577 0-.007-.004-.01-.01-.009-.015.002-.006.004-.01.006-.01h.651c.035-.016.069-.024.103 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0063AE",
    d: "M6.902 3.455c-.05.052-.114.026-.171.027-.185.002-.37 0-.555-.001.097-.05.201-.017.302-.022.14-.007.283-.003.424-.004",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2571B8",
    d: "M8.491.456c-.004.036.006.083-.052.082-.058 0-.05-.046-.052-.083-.002-.048.02-.069.068-.069.06 0 .04.038.036.07",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0065A4",
    d: "M7.813 1.922h-.022l-.008-.545c-.01-.02-.011-.039.01-.053.046.198.009.398.02.598",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3F1F8",
    d: "M7.498 2.018c-.01.128-.04.248-.131.345.034-.119.067-.238.131-.345",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116FB5",
    d: "M6.014.96c.036.074.07.149.086.23l-.052.03c.024-.092-.1-.164-.034-.26",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#056EB0",
    d: "M5.834 2.73l-.004-.07c.005-.014.02-.039.02-.036.019.069.083.129.043.209-.018.001-.022-.017-.033-.025-.028-.02-.019-.052-.026-.079",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0077BE",
    d: "M4.53 3.13c-.065-.086-.05-.14-.027-.231.043.088.027.142.028.232",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2571B8",
    d: "M8.595.386v.156c-.08-.052-.081-.104 0-.156",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00649D",
    d: "M7.84 3.457c0 .008.001.017.003.025-.002.007-.003.014-.002.02-.075.008-.053-.049-.054-.086-.002-.047.002-.093.004-.14h.022c.011.06-.024.127.027.18",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEDF5",
    d: "M5.86 2.808c.01.009.022.017.033.025l.053.18c-.07-.051-.072-.13-.086-.205",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#166FB1",
    d: "M5.858.543c.02.028.034.059.035.095-.018.025-.037.02-.048-.003C5.83.603 5.827.57 5.858.543",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0069B0",
    d: "M5.682 2.285c-.01-.033-.022-.065-.033-.098.063.015.067.05.033.098",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77C4ED",
    d: "M7.793 1.324l-.01.053-.047-.001c-.003-.035.012-.063.033-.089l.024.037",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E6CB1",
    d: "M5.627 2.13l-.028-.075c.022-.026.036-.009.046.01.012.026.007.048-.018.065",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0671AD",
    d: "M6.253 1.606l.02.007.032.125c-.065-.025-.052-.08-.052-.132",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#146FB7",
    d: "M27.236.412c-.178.027-.358.034-.536.022-.07-.005-.136.044-.207.01-.006-.003-.025.01-.029.019-.009.023.001.046.026.048.066.007.07.05.07.102l-.001 1.144c0 .011-.007.022-.025.033 0-.355.002-.71-.002-1.063-.001-.059.034-.17-.034-.168-.086.004-.04.113-.04.174-.005.346-.001.693-.004 1.04 0 .073.016.132.068.186.077.078-.036.163.013.245-.063-.048.025-.15-.08-.178-.019.008-.031.002-.037-.019-.003-.505.001-1.011-.003-1.517 0-.086.017-.124.113-.119.237.012.474-.011.711.012h-.001c.006.007.008.014.005.02-.002.006-.005.009-.007.009",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006CB5",
    d: "M27.236.412l.002-.029c.047.015.034.055.034.087v2.95c0 .012-.004.025-.006.038-.01.009-.02.01-.03-.002V.412",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#206DB6",
    d: "M24.034 3.067v.204h-.019V.57h.02v2.496z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0063AD",
    d: "M27.236 3.456l.03.002c.003.066-.048.05-.082.05h-.897c-.04 0-.08 0-.094-.049.348 0 .695-.002 1.043-.003",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006CAC",
    d: "M24.838 1.636v1.691c-.007.013-.015.013-.022 0-.01-.547.015-1.094-.012-1.641-.002-.026.014-.039.034-.05",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#106FB6",
    d: "M25.8 2.892c-.085-.123-.172-.245-.258-.367.006-.025.01-.06.043-.022.034.039.062.083.09.126.02.027.016.071.076.024.045-.035.077.03.077.079 0 .042-.015.084-.023.126.011.013.01.024-.004.034",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0971AB",
    d: "M24.789 3.504c-.212.002-.423.004-.634.004-.183.001-.183 0-.17-.18.02.012.022.03.023.051l.001.077c.197.034.394.006.591.014.056.003.112 0 .168.002.02.003.027.013.02.032",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#206DB6",
    d: "M24.112.542V.516c.029-.032.067-.037.106-.038.22-.002.438-.001.657 0 .059 0 .11.017.148.064-.013.01-.029.031-.04.029-.288-.064-.58-.013-.87-.03",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0063AD",
    d: "M24.788 3.482h-.659c-.04 0-.087.016-.12-.026h.804c.009.026.005.038-.025.026",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0070B4",
    d: "M25.936 1.608l.023.005.137.221-.09.099c.04-.09.014-.154-.05-.218-.024-.023-.068-.062-.02-.107",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1170B0",
    d: "M25.493.954l.005.02c-.091-.013-.128-.068-.117-.17l.112.15",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0072B6",
    d: "M26.274 2.103l.104.137c.016.01.034.017.046.033l.006.013c-.082.017-.163-.077-.156-.183",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006CB4",
    d: "M26.432 2.027l.023-.001c-.022.085.043.179-.025.26-.023-.087-.023-.173.002-.26",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E69B2",
    d: "M25.287.67l.048.081c-.028.044-.072-.008-.124.039.026-.062.042-.096.076-.12",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D6EB6",
    d: "M24.887 1.56l-.04-.024c-.02-.013-.033-.03-.018-.052.015-.022.035-.02.053-.002.023.024.053.05.005.079",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B70A3",
    d: "M24.788 3.482l.025-.025c0-.044.002-.087.003-.13h.022v.179l-.05-.002v-.022",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066AB",
    d: "M25.8 2.892l.005-.034c.027.02.073.033.027.078l-.031-.044",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAF9",
    d: "M19.006 5.151c.042.03.09.054.124.091.08.085.106.185.066.3-.045.129-.142.202-.272.206-.315.01-.63.004-.946.007-.05 0-.068-.022-.068-.07.001-.16.003-.32 0-.48-.002-.079.045-.078.1-.078.29 0 .58-.003.87-.004.049-.024.087.005.126.028",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#156EB7",
    d: "M17.082 7.518c-.026-.043-.026-.09-.025-.139V4.61c0-.033-.007-.068.02-.106.057 1.011.022 2.013.032 3.014-.01.01-.018.01-.027 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#226DB5",
    d: "M17.213 4.447h1.557c.046 0 .097-.017.135.026l-1.558-.001c-.045 0-.096.017-.134-.025",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#046AB4",
    d: "M19.006 5.151l-.127-.028c-.039-.042-.09-.025-.135-.025-.24-.002-.482 0-.722-.016.332.019.667-.067.996.04.007.002.012.008.018.012l-.03.017",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0062AB",
    d: "M20.233 7.493l.026.025c-.018.025-.044.024-.07.024-.289 0-.577 0-.866-.024h.745c.056 0 .113.006.165-.025",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066B1",
    d: "M18.896 5.797h-.92v-.012h.926l-.006.012M17.867 7.406v-.894h.012v.9l-.012-.006",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116DB3",
    d: "M19.687 6.22c-.074.074-.174.102-.263.15-.055.019-.105.064-.17.035-.017 0-.04.005-.048-.003-.016-.016.004-.038.016-.039.165-.01.299-.107.448-.16.003-.002.011.01.017.016",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061AB",
    d: "M17.082 7.518h.027c.255-.015.513.033.767-.027l.007.048c-.252 0-.503.002-.754.003-.026 0-.052 0-.07-.023l.023-.001",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0065AF",
    d: "M17.881 5.152v.536h-.009v-.536h.01",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#176FB3",
    d: "M19.56 6.788c.066.066.148.117.182.21-.09-.045-.193-.079-.182-.21",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061AD",
    d: "M20.075 5.28l.025.084-.023.2c-.009.014-.017.014-.026.002.012-.095-.028-.194.024-.285",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B6FAF",
    d: "M19.943 4.89c.046.059.076.124.088.198-.06-.031-.108-.14-.088-.198",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7E2F3",
    d: "M19.254 6.405l.17-.035.001.029c-.056.01-.108.029-.134.087-.065-.003-.051-.042-.037-.08",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1274B3",
    d: "M20.05 5.566l.026-.001c.006.1-.024.189-.074.273-.008-.095.048-.179.049-.272",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7E2F3",
    d: "M19.311 6.507c.079.038.141.091.168.177-.031.017-.04-.004-.048-.028l-.12-.149",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#186EAE",
    d: "M19.195 7.543l-.055-.079c.061-.045.078.02.104.048.024.024-.007.03-.027.034l-.022-.003",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#226DB5",
    d: "M18.905 4.473c.06-.005.122-.06.182 0-.06-.016-.121.065-.182 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006DA9",
    d: "M19.43 6.656l.049.029.028.047c-.062.011-.086-.015-.076-.076",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF6F5",
    d: "M13.698 1.714l-.026.001c-.044.032-.087.03-.13-.002l-.027-.052c-.019-.078-.02-.156 0-.234.027-.119-.028-.245.033-.36.04-.041.082-.035.123-.002h.026c.235-.023.47-.027.704-.001.068.026.146.004.21.047.009.014.008.027-.004.038-.025.017-.053.02-.081.019-.277-.033-.549.047-.825.04-.074-.001-.103.027-.098.098.002.026 0 .052 0 .078 0 .211.02.231.236.24.218.01.433-.013.649-.032.043-.003.086-.016.125.014.023.071-.027.098-.075.126-.23 0-.46.012-.691.007-.05-.001-.104.01-.149-.025",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#046DB6",
    d: "M12.655 3.431l-.005-2.138c0-.25.004-.501.006-.752.01-.01.018-.009.026 0l.001 2.599c0 .073.006.146.012.219.003.035.017.071-.04.072",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0065AE",
    d: "M15.835 3.43l.024.028c.016.049-.034.03-.048.047-.297.001-.593.001-.89.005-.092 0-.155-.034-.188-.122l.008-.01c.22.138.464.067.697.076.131.006.267.03.397-.023",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2168B2",
    d: "M12.683.542h-.027V.385h1.86c-.051.04-.093.025-.13.025-.52.001-1.04.003-1.56-.002-.1 0-.155.023-.143.133",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2570B7",
    d: "M14.817 1.505c.048-.026.004-.11.086-.121-.009.082-.093.178.034.238.006.002.006.035-.001.046-.013.017-.027 0-.042-.008-.028-.016-.06-.026-.064-.067-.053.04-.032.076-.019.113.033.088-.034.129-.09.163-.055.034-.075-.04-.066-.057.02-.04-.006-.051-.02-.073-.006-.006-.009-.013-.007-.02.001-.007.003-.01.005-.01.034-.014.079-.013.08-.067.007-.027.018-.052.03-.077.006-.01.012-.018.02-.027.015-.016.03-.03.054-.033",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#046DB4",
    d: "M14.635 1.713v.026c-.131.085-.27-.017-.41.019-.134.034-.283.008-.426.007-.04 0-.091.014-.1-.05l.857-.012c.026-.01.05-.032.082-.02.007.01.006.021-.003.03",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0062AC",
    d: "M13.515 3.432c.013.058-.013.077-.069.076h-.723c-.034 0-.073.004-.067-.05h.709c.052 0 .103.002.15-.026",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#076EB1",
    d: "M15.448 3.039l-.032.002c-.153-.058-.188-.236-.32-.316-.027-.016-.017-.055-.014-.084.026-.002.034.02.048.035l.025.027c.033.018.058.046.08.077l.213.259",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006DB4",
    d: "M14.401 1.064h-.704c.086-.059.183-.017.274-.027.123-.012.249.019.371-.02.039-.012.055.012.06.047",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F6DB3",
    d: "M14.28 2.907c-.027-.052-.064-.094-.114-.126l-.027-.049c.056-.016.125-.07.125.054 0 .042.04.072.077.096.037.023.044.05.008.08l-.07-.055",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEDF4",
    d: "M14.817 1.505l-.046.056c-.016-.009-.03-.025-.025-.04.047-.16-.034-.274-.137-.38l.002-.03c.175.054.225.15.206.394",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1371B6",
    d: "M14.632 3.277c-.068-.048-.117-.112-.163-.18.094.024.173.062.163.18",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCE4F2",
    d: "M15.13 2.676l-.048-.035-.02-.02c-.045-.013-.074-.041-.086-.087l-.03-.04c.087.036.168.077.184.182",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A6AB2",
    d: "M13.671 1.065l-.122.001c-.012-.004-.035-.01-.034-.012.013-.053.05-.045.094-.05.057-.004.069.012.062.06",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066AE",
    d: "M13.575 2.398l-.035.003c.01-.083.071-.028.107-.035.05-.01.102-.002.154.016l-.226.016",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0072B1",
    d: "M15.23 2.228l-.074.026c.015-.089.102-.103.156-.15.015.01.016.02.003.033l-.086.091",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#046DB4",
    d: "M13.542 1.713l.13.002c-.001.058-.035.057-.083.06-.06.002-.045-.032-.047-.062",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0068AC",
    d: "M14.092 2.675l-.11-.124c.076.006.122.04.11.124",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0079BF",
    d: "M14.921 3.337c.027.008.025.031.024.052 0 .018-.013.038-.03.028-.015-.009-.027-.033-.03-.051-.002-.017.017-.028.036-.029",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0070AD",
    d: "M13.515 1.427v.234c-.04-.078-.04-.156 0-.234",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0069AC",
    d: "M15.315 2.137l-.003-.033c.05-.004.057-.101.128-.058-.036.038-.065.086-.125.09",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006DB2",
    d: "M15.652 1.69c.002.029-.01.053-.029.075-.045-.038-.018-.076.008-.104.014-.014.016.016.021.028",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0067AB",
    d: "M14.976 2.535l.085.087c-.061.003-.088-.028-.085-.087",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFCFD",
    d: "M2.554 1.844c.032.08.06.161.097.239.034.071.023.096-.06.095-.212-.003-.424.002-.636.004-.016.016-.034.016-.051.001-.087 0-.125-.019-.078-.12.136-.298.263-.602.405-.929l.243.529c.048.05.078.11.08.18",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C6FB7",
    d: "M1.461 2.834c.033-.02-.077-.114.016-.07.113.053.196-.014.292-.012.324.007.648.003.972.002.074 0 .17.03.17-.102 0-.018.025-.045.058-.035-.052.067.087.039.052.104-.017.032-.016.074-.024.112-.036.021-.076.012-.114.012h-1.32c-.034 0-.07.009-.102-.011",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0063AD",
    d: "M1.2 3.483c-.014.03-.042.024-.067.024L.315 3.5c-.013-.015-.012-.03.001-.045l.882.004c.009.004.012.009.01.014-.002.006-.005.009-.007.009",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005AA5",
    d: "M1.461 2.834l1.536-.001-.029.027c-.447.002-.893.002-1.34.005-.056 0-.113-.013-.165.02-.033-.017-.004-.034-.002-.051",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E6BB4",
    d: "M1.817.394h.812c-.269.088-.542.013-.812 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0169B3",
    d: "M1.904 2.183l.051-.001c.08.052.169.021.253.024.15.006.3.002.45.022h-.804c0-.032.045-.018.05-.045",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D70B7",
    d: "M.964 1.942l.108-.255c.022-.004.034.001.025.027.02.066.044.134-.008.195-.032.037-.08.038-.125.033",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0872B4",
    d: "M1.224 1.37c.06-.143.104-.295.21-.415-.025.142-.11.262-.147.4-.009.031-.03.057-.063.015",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0064AE",
    d: "M3.275 3.489l-.017-.031h.826v.03h-.809z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#096DAE",
    d: "M1.2 3.483l-.002-.023c.036-.194.059-.24.138-.281-.036.105-.072.21-.135.304",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#206DB3",
    d: "M1.486.75l.081-.103c.033.092-.066.15-.064.237 0 .011-.04-.021-.063-.029l.03-.1c.007.002.012 0 .016-.006",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#096EB4",
    d: "M1.097 1.714l-.025-.027.079-.155c.053.082.004.133-.054.182",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0271AF",
    d: "M2.554 1.844c-.035-.057-.065-.116-.08-.181.094.03.098.101.08.18",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0672B3",
    d: "M3.494 1.862c.038.049.064.103.075.164-.086-.027-.078-.097-.075-.164",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 7) translate(0 3.187)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f64twnaoil",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j8lf3q5lhk"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00619B",
    d: "M.405.345v.058C.24.353.393.296.4.242l.005.103",
    mask: "url(#f64twnaoil)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75AE",
    d: "M.347 3.255c.007-.002.014-.005.02-.009 0 .052-.003.103-.059.13l.04-.121",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F9FB",
    d: "M21.405 2.183c-.067-.01-.056-.048-.035-.092l.13-.277c.076-.048.054-.142.098-.205.074-.083.097-.183.094-.291.003-.026.015-.048.031-.068.049-.048.081-.05.112.023.052.123.092.25.168.361.068.153.134.306.206.457.032.068.02.087-.056.087-.18-.002-.36.003-.54.005-.07.039-.139.06-.208 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1970B7",
    d: "M22.568 2.914c-.02-.008-.024-.023-.02-.043-.03-.05-.077-.024-.116-.024-.456-.003-.913 0-1.37-.003l-.022-.012c.035-.046.091-.01.132-.034.022-.056-.045-.073-.05-.096l1.176.001c.05 0 .105-.02.148.026-.176.027-.353.009-.53.011-.212.003-.424.003-.636 0 .371.002.742.002 1.112.002.058-.005.09.063.145.053-.028-.006-.062-.01-.087-.036-.008-.006-.011-.012-.01-.02.002-.007.004-.01.006-.01.03-.005.073.001.084-.015.02-.03.016-.085.072-.055.053.028.06.084.049.136-.009.04-.032.077-.049.115-.01.016-.021.017-.034.004",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0064AD",
    d: "M23.721 3.406l.002-.03c.04.028.078.072.06.113-.018.041-.077.016-.117.017-.224.002-.449-.011-.671.004-.15.011-.214-.048-.237-.182.108.173.28.128.439.13l.426-.001c.04 0 .09.014.098-.051",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0062AD",
    d: "M20.755 3.487c-.185.045-.374.016-.56.018-.116 0-.236.031-.35-.022.06-.04.126-.024.189-.025.223-.003.446-.001.67-.006.033-.001.047.005.051.035",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#286FB7",
    d: "M21.434 1.566c-.005.011-.025.023.003.036.015.006.073-.048.04.023-.01.02-.003.072-.043.06-.023-.006-.071 0-.072-.038-.002-.078-.05-.132-.08-.197-.022-.044-.018-.106.051-.123.071-.017.092.049.08.084-.022.062.07.096.02.155",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A69B3",
    d: "M22.263.365h.027c.04.054.01.062-.04.06-.16-.005-.322-.004-.484-.015-.11-.007-.22.057-.33.004-.034-.016-.091.106-.11-.028l.8-.001c.046 0 .096.016.137-.02",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D6FB3",
    d: "M21.043 2.862l-.246.543c-.038-.007-.055-.035-.034-.064.101-.132.13-.294.196-.44.018-.04.036-.066.08-.069l.002.001c.008.006.011.012.01.019-.003.007-.005.01-.008.01",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2270B7",
    d: "M23.07 1.87l.079.182v.026c-.146-.144-.22-.319-.236-.52l.157.311",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D6FB5",
    d: "M21.73 1.268l-.016.048c-.014.03-.007.073-.051.085-.047-.042-.007-.078.007-.116.016-.044.041-.086.036-.134-.003-.03-.03-.06 0-.09.024.08.064-.049.1.01.027.043.06.073.02.121-.063-.013-.06.055-.095.076",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A71B5",
    d: "M20.917 1.039l.05-.08c.022.02.029.049.017.07-.073.14-.119.292-.207.423-.002.003-.007.007-.009.006l-.02-.014.169-.405",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0469B3",
    d: "M21.405 2.183c.07.03.139-.006.208 0 .115.053.236.015.355.024.08.006.161 0 .242.026h-.756c-.032 0-.045-.022-.049-.05",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8F3F7",
    d: "M21.73 1.268c.045-.12.045-.12.095-.076l.178.443c-.113-.085-.126-.225-.177-.341-.033-.076-.056-.045-.095-.026",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D6EB6",
    d: "M21.138.885c0 .102.004.182-.002.26-.002.03-.018.075-.063.065-.047-.01-.038-.055-.029-.084.024-.075.057-.147.094-.24",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#146EB4",
    d: "M20.203 2.638c.029-.107.083-.203.134-.3.052.068.045.102-.008.153-.067.063-.078.16-.122.238-.023-.03-.011-.06-.004-.091",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0571B5",
    d: "M22.71 1.16c.07.087.12.185.154.291-.005.03-.023.057-.044.02-.05-.085-.089-.176-.13-.265-.004-.01.013-.03.02-.046",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8F3F7",
    d: "M21.663 1.4l.051-.084c.003.11.015.224-.1.294-.017-.018-.015-.037-.003-.056l.052-.153",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F7F2",
    d: "M19.924 3.154c.038-.105.049-.226.157-.293l-.033.12c-.018.058-.036.115-.078.16l-.046.013",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0EFF2",
    d: "M21.611 1.555l.003.055c-.057.058.017.187-.114.204.025-.092.06-.18.111-.26",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A71B3",
    d: "M22.44.494l.013.07c-.074-.046-.1-.119-.111-.2.07.015.053.096.099.13",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0073B2",
    d: "M19.97 3.142c.018-.057.035-.115.078-.16 0 .065-.004.13-.078.16",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#166AB3",
    d: "M20.203 2.638l.004.09c-.014.022-.023.061-.057.019.01-.04.021-.08.053-.109",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F70AD",
    d: "M22.45.563c.034.028.044.068.057.106-.06-.014-.065-.056-.056-.106",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D70A8",
    d: "M22.568 2.914l.034-.004c.02.037.03.076.023.118l-.057-.114",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F70B8",
    d: "M29.715 7.162c-.057.094-.137.16-.235.207-.048-.016-.087.034-.135.02-.028-.025.015-.074-.03-.09-.047-.017-.165.005-.036-.09.026-.02-.044-.064-.067-.098-.012-.017-.032-.037-.03-.053.005-.029.036-.03.062-.034.116-.015.228.007.328.062.028.015.103-.055.086.042-.023.024-.054.039-.074.067.023-.024.05-.044.074-.067.025.001.046.01.057.034",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#216BB4",
    d: "M29.791 4.535c.003.006.002.011-.003.015-.041-.067-.102-.08-.177-.079-.45.003-.901.004-1.352 0-.189 0-.378-.018-.563.034-.03.008-.04-.005-.043-.03l.163-.04c.04-.006.084.01.123-.012l1.668-.001c.035.021.075.013.112.011.081-.004.095.035.072.102",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0060AB",
    d: "M28.88 7.548l-1.678-.006c-.047 0-.094 0-.141-.024h1.764c.032-.017.056-.018.054.029z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105DAB",
    d: "M27.005 6.892c-.005-.008-.004-.016.003-.023h1.79v.023h-1.793z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116EB3",
    d: "M28.88 7.547c-.012-.022-.033-.028-.055-.029.153-.042.315-.046.465-.103.019-.008.037-.018.055-.027.04-.036.079-.089.134-.019-.18.127-.381.18-.6.178",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#186DB6",
    d: "M28.104 5.015h1.253v.016h-1.258l.005-.016",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296FB5",
    d: "M29.006 6.71l.02-.001c.017.003.056-.021.049.009-.014.06.013.132-.041.183-.026.024-.067.026-.08-.003-.022-.05-.08-.022-.103-.059l.079-.045c.029-.024.059-.048.076-.083z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0076BD",
    d: "M27.8 5.154c-.039.005-.065-.01-.08-.037-.026-.047-.019-.1-.006-.15.004-.016.025-.027.042-.016.047.029.02.078.028.117l.016.086",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D6BB4",
    d: "M27.788 5.264c-.048.038-.019.09-.026.137-.005.038-.018.07-.057.087V5.41c-.024-.02-.041-.044-.026-.078.068-.094.068-.094.109-.068",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0078BE",
    d: "M27.679 5.332l.026.078c-.04.026-.02.092-.079.114-.04-.08-.05-.15.053-.192",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#166CB1",
    d: "M27.021 4.936c.026-.092.089-.156.16-.214-.034.086-.047.187-.16.214",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006DAE",
    d: "M26.95 5.096c.006-.062.031-.115.073-.16.003.066-.001.129-.074.16",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1660AB",
    d: "M29.055 6.657v-.122c.035.041.073.082 0 .122",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 7) translate(29.659 6.309)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "k0iuzsvjmn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#20snskh42m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0065A2",
    d: "M.328.218L.326.414C.286.35.283.284.328.218",
    mask: "url(#k0iuzsvjmn)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F70B8",
    d: "M23.851 6.998h.013c.069 0 .153-.023.203.008.067.042-.017.117-.01.183.008.073.012.142.044.21.022.047.023.101-.06.073-.066-.021-.127.007-.19.02-.098-.098-.036-.221-.05-.332-.006-.057-.017-.124.05-.162",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0070B4",
    d: "M26.251 7.364c-.194.156-.427.194-.663.197-.576.007-1.152.003-1.728.003-.022 0-.044.002-.058-.02.04-.023.084-.011.126-.012l1.517-.001c.042 0 .086.017.125-.013.103-.025.206-.053.314-.052.093.002.164-.062.248-.086.04-.012.075-.045.12-.016",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#236FB7",
    d: "M23.7 5.591c.033-.02.055-.046.041-.085-.048-.138-.014-.263.059-.382.019.008.054.016.054.025.01.22.032.44-.073.648-.002.003-.007.005-.01.008v-.003c-.012-.02-.01-.044-.015-.067 0-.025.012-.05 0-.075-.012-.01-.025-.012-.038-.012l-.017-.057",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006BB1",
    d: "M23.815 6.87c.028-.052.076-.024.114-.024.515-.002 1.03-.002 1.544 0 .097 0 .19-.011.276-.057.019-.015.037-.016.056 0-.051.072-.114.12-.209.105-.044-.026-.093-.013-.14-.013h-1.594c-.017 0-.032-.003-.047-.012",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0060AA",
    d: "M25.57 7.518c-.026.047-.071.023-.106.023l-1.662.004-.002-.004c-.006-.024.005-.03.027-.024h1.743",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F70B7",
    d: "M24.789 5.096c-.031-.056-.03-.08.05-.079.418.005.836.001 1.254.004.07 0 .126-.008.154-.08.039.124.031.138-.102.14-.332.003-.663 0-.995.001-.06 0-.12-.005-.18.01-.06.011-.12.029-.181.004",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1561AC",
    d: "M23.829 6.873l1.697-.004c.026 0 .052.001.07.025l-1.769-.003c-.007-.005-.009-.009-.006-.013.003-.003.005-.005.008-.005",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCE2EF",
    d: "M26.322 5.117c-.032.055-.085.032-.129.032-.351.002-.703.001-1.054.002-.151 0-.303-.008-.452.025l.081-.049c.027-.024.061-.023.093-.029.442-.024.883-.006 1.325-.01.047-.001.096-.004.136.029",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0863AE",
    d: "M24.549 6.324c-.117-.003-.227-.031-.331-.083.079-.044.146.012.218.026.235.05.473.021.71.027.14.004.282 0 .424.03h-1.021z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006BB3",
    d: "M24.842 5.12l-.074.007-.014-.02.035-.01c.049-.03.103-.026.157-.026.118-.027.239-.01.358-.011.323-.003.646-.001.968-.001.02.001.03.012.03.031-.04.038-.09.019-.136.019-.399.002-.797 0-1.196.002-.042 0-.086-.009-.128.009M23.829 6.873l-.002.018c.002.037-.013.078.024.107-.045.165-.035.33 0 .494l-.024.025-.027.024c-.035-.22-.014-.44-.006-.66 0-.005.014-.008.02-.012.006 0 .01.002.015.004",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#216BB4",
    d: "M26.195 4.447v.026h-1.218v-.026h1.218z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B64AF",
    d: "M25.785 5.64l.07.005c.018.03-.01.037-.025.05-.16-.048-.326-.02-.489-.024-.192-.004-.384 0-.576-.03h1.02z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1171B3",
    d: "M25.83 5.696l.025-.051c.162.014.323.03.448.152-.163-.01-.31-.095-.473-.101",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1669AC",
    d: "M26.663 6.244c.027.045.033.096.03.147.015.1.016.201 0 .302l-.005.043c-.04-.162-.03-.327-.025-.492",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6EBF4",
    d: "M25.752 6.477l.005-.03c.11.052.07.15.072.235-.018.02-.004.068-.053.062-.038-.031-.05-.068-.024-.113.064-.051-.043-.103 0-.154",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0079BF",
    d: "M24.625 5.646c.032.01.07.025.063.064-.004.023-.03.061-.062.052-.03-.008-.072-.035-.075-.058-.004-.033.034-.054.074-.058",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1370B8",
    d: "M26.507 5.957c.04.07.116.12.13.208-.09-.005-.08-.164-.197-.126-.002-.048.037-.062.067-.082",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F7F5",
    d: "M25.57 6.373l.18.053c.005.006.007.013.006.021-.076.04-.126-.025-.186-.048-.008-.006-.011-.011-.008-.017.003-.006.005-.009.008-.009",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCE2EF",
    d: "M24.605 5.252l-.028.186c-.042-.07-.027-.13.028-.186",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#026EB3",
    d: "M26.301 5.796c.045 0 .078.02.104.054-.08.069-.08-.017-.104-.054",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1774AB",
    d: "M25.776 6.733c.032-.002.033-.037.053-.051.006.039-.006.074-.024.107h-.056l.009-.049c.002-.012.008-.015.018-.007",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCE2EF",
    d: "M24.685 5.227l-.08.025c.009-.044.034-.07.08-.075v.05",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006BAC",
    d: "M23.82 4.907l.03-.045c.043.025.01.052.002.079l-.031-.034",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E70B7",
    d: "M17.939 3.12l-.1-.106-.002-.024c.102-.063.166.002.234.064.038.036.06.084.139.018.06-.052.18-.025.248.058.044.054.028.143.123.172.033.01-.027.05-.04.077-.052.03-.093-.004-.137-.022-.029-.028-.059-.052-.103-.042-.045-.004-.08-.046-.128-.034l-.234-.162z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D6FB4",
    d: "M20.155 1.085c-.345.02-.69.007-1.036.006-.042.023-.093-.004-.135.02l-.027.004c-.009-.005-.012-.011-.009-.018.003-.006.006-.008.009-.008.072-.045.153-.053.235-.053.26 0 .52-.005.78.003.125.004.172-.05.155-.16-.018-.114.058-.24-.046-.341.056-.05.057-.099-.018-.144.1-.02.091.04.091.093l.001.598",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1771B8",
    d: "M18.472 1.43l-.027.077c-.009.08-.035.158-.053.237-.014.117-.01.234-.002.35.03.136.088.263.126.396-.046.05-.054-.003-.069-.028-.03-.049-.04-.121-.128-.064-.035.022-.043-.023-.035-.043.004-.011-.05-.082.034-.045.024.011.04-.039.028-.066-.07-.17.002-.356-.08-.524.057-.008.026.044.063.045-.007-.112.064-.206.068-.318.002-.068.051-.003.075-.017",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D6FB3",
    d: "M19.431 3.384l-.035.117c-.253.014-.504.023-.751-.044-.016-.017-.016-.034 0-.052.185.036.372.059.562.053.133-.004.133-.001.146-.132.03.017.037.061.078.058",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2EFF6",
    d: "M18.61 2.577c.038-.03.062-.003.087.021.022-.001.045 0 .063.01.233.142.491.105.744.11.085.002.176-.01.238.071 0 .017-.007.029-.023.035-.17-.008-.338-.003-.507-.005-.125-.02-.256-.006-.374-.065-.05-.025-.106-.036-.138-.087l-.09-.09M18.516 2.49c-.077-.118-.111-.251-.136-.387-.013-.121-.015-.242.001-.363.015-.08.024-.16.065-.233.026.03.016.064.006.098-.088.305-.052.596.103.873.008.014.006.034.008.05l-.047-.038",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F7F2",
    d: "M19.842 3.015c-.012.002-.029 0-.037.008-.09.084-.133.055-.14-.059l.021-.081c-.018-.046.024-.053.047-.073l.008-.006c.035-.019.072-.022.08.023.008.04-.021.05-.057.032-.052.05-.014.08.03.087.05.008.05.034.048.069",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#076DB2",
    d: "M18.645 3.406v.05c-.17-.023-.324-.09-.472-.175.055-.063.089.017.134.02.044-.03.07.011.103.026.037.035.085.041.13.052.033.018.067.03.105.027",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#156BB2",
    d: "M18.7 2.667c.155.085.325.115.497.135-.028.037-.078 0-.11.03-.12.009-.226-.042-.332-.088-.033-.014-.062-.033-.055-.077",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2168B2",
    d: "M19.969.406h-.827V.393h.823c0 .004.002.009.004.013",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005FA7",
    d: "M19.088 2.832c.029-.037.074-.016.11-.03.178 0 .357-.014.535.008l-.047.073c-.034-.046-.082-.051-.136-.05h-.462",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006DB0",
    d: "M18.957 1.088v.028l-.101.027c-.02-.008-.063-.016-.018-.04.032-.018.079-.01.12-.015",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#126FB1",
    d: "M19.636 2.991c-.01.038-.022.075-.053.102.003-.04-.004-.087.013-.12.023-.043.033-.004.04.018",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0070AF",
    d: "M19.481 3.304c-.005.035-.016.065-.05.08.011-.03-.054-.108.05-.08",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0071A9",
    d: "M18.749.414l-.062-.005c.05-.035.108-.026.164-.026-.024.043-.068.023-.102.03",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1666AE",
    d: "M17.684 2.753c-.022-.02-.032-.045-.036-.074.057.003.078.023.036.074",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M19.764 2.859c.018-.005.047-.003.039-.031-.008-.029-.04-.019-.062-.024-.058-.043-.125-.05-.195-.05-.151.001-.303.002-.454 0-.15-.002-.274-.077-.395-.156v-.052c.071-.004.143.015.209-.042.03-.027.083-.014.119.019.132.121.295.062.446.074.014.001.042-.01.042-.018.014-.172.15-.136.246-.129.102.009.15-.032.188-.112.028.02.035.06.08.085-.016-.055-.051-.08-.08-.111 0-.051.044-.06.082-.074.019.014.02-.008.01.007l-.01-.007c-.02-.025-.035-.046-.052-.065-.035-.04-.05-.092-.014-.129.043-.044.09-.01.12.03.038.053.07.07.096-.004.018-.053.059-.046.096-.043.047.004.093.013.14-.002-.03.059-.042.126-.141.11-.06-.008-.102.051-.089.117.02.1-.014.18-.06.266-.047.085-.14.036-.194.087-.024.023-.07.028-.057.074.012.039.033.046.078.025.036-.017.08.11.05.161-.022.037-.05.07-.08.113-.012-.097-.14-.027-.158-.12",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F9F4",
    d: "M19.947 2.312c.11-.007.105.069.11.144-.083-.001-.123-.036-.11-.118v-.026",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M20.155 1.167c.026-.034.052-.034.078 0-.026.006-.052.041-.078 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M23.308 5.098c-.033.054-.087.028-.13.028-.542.002-1.084.003-1.626-.001-.095-.001-.135.022-.125.122.009.086.008.174 0 .26-.007.092.025.118.117.117.507-.004 1.014-.003 1.522 0 .062 0 .129-.023.188.018-.034.029-.075.014-.112.014h-1.633c-.088.01-.136-.008-.12-.118.014-.105.005-.214 0-.32.004.106.014.215-.002.319-.016.109.028.13.118.12l1.68.001c.06.02.054.07.055.118l.001.426c-.007-.173.006-.345-.004-.517.001-.016.007-.03.018-.042.041.232.009.466.017.699l.006.005-.005-.006c-.568.002-1.136.007-1.703.002-.115 0-.158.029-.142.144.016.114-.05.262.029.336.07.066.215.018.327.019.468.002.936 0 1.404.003.039 0 .112-.044.119.049-.018.006-.032.002-.045-.011-.58-.007-1.161.001-1.74-.005.003.02.024.003.036.003h1.586c.043 0 .087-.007.13.009.04.111.007.226.018.34.007.07-.017.143.017.211v.026c-.024.02-.016.066-.059.073-.665.01-1.33.001-1.995.004h-.466c-.059-.005-.12.013-.176-.02-.033-.033-.041-.074-.041-.12.002-.95-.006-1.9.004-2.85.004-.016.014-.029.028-.038.09-.02.13.018.124.11-.009.127.025.258-.052.379-.025.039-.012.093-.012.14 0 .559.004 1.118-.003 1.676-.002.15.116.276.067.406-.029-.681-.009-1.386-.014-2.09-.001-.17.018-.337.016-.507-.001-.086-.022-.133-.117-.12-.055-.037-.022-.063.01-.09h.053c.06.035.126.026.19.026l2.248.001c.056 0 .113-.01.165.02.022.203.018.405.002.607-.18.022-.362.008-.543.01-.325.002-.649 0-.973 0-.04 0-.083-.007-.12.012-.016.01.012.02 0 .006-.004-.007-.002-.01.007-.012.125-.012.25-.004.374-.005h1.155c.042 0 .086-.011.127.013",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#216BB4",
    d: "M23.279 4.472h-2.412c-.068 0-.14.012-.19-.052.81-.002 1.62-.004 2.432-.003.057 0 .12-.026.173.02.009.013.008.025-.003.035",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0068A4",
    d: "M20.623 4.42l-.025.079c.009.005.012.011.009.017-.003.006-.006.009-.01.009-.023.036-.013.076-.013.114v2.72c0 .043-.005.087.014.128.008.017.006.032-.006.046l-.022.013c-.041-.035-.02-.081-.02-.122-.002-.96-.002-1.921 0-2.882 0-.049-.041-.136.073-.122",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00659D",
    d: "M23.278 7.518c.002-.022.007-.042.03-.052.03.112-.048.095-.111.095-.713 0-1.427.002-2.14 0-.162-.002-.326.022-.487-.015l.01-.008c.072-.014.145-.003.217-.006h2.34c.047-.001.096.012.14-.014",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006BB4",
    d: "M23.308 5.098h-1.662V5.07h1.633c.01-.014.02-.014.029 0v.027",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006AB2",
    d: "M23.308 5.071h-.03l.001-.599.003-.034c.032.01.034.037.034.063l-.008.57",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0069B3",
    d: "M23.309 7.441c-.063-.086-.02-.183-.028-.275-.008-.09-.002-.182-.002-.273h.028c.014.183.01.366.002.548",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF5F7",
    d: "M6.512 4.395c.03-.028.055-.063.104-.053 0 .021.004.04.027.049.053-.036.114-.035.175-.035h2.08c.074 0 .147.006.216.035.022.002.042-.001.054-.022h.026c.091-.01.17.05.26.051.021 0 .044-.016.065.003.07.087.16.155.225.246.277.301.556.6.836.9.04.043.11.078.073.16-.086.03-.153-.036-.231-.05-.02-.003-.037-.03-.032-.05.029-.118-.06-.168-.129-.23-.11-.118-.223-.234-.33-.355-.016-.018-.028-.038-.039-.059-.028-.053-.09-.074-.126-.12-.019-.02-.033-.042-.05-.063-.068-.092-.173-.144-.242-.235-.04-.053-.077-.039-.08.026-.009.121-.01.243.006.364.026.192-.028.255-.224.256-.5.003-.998 0-1.497.001-.172 0-.249.124-.18.283.024.058.073.055.12.055.195.003.39.003.585.001.317-.003.634.011.95-.009.115-.007.181.045.199.159 0 .015 0 .03-.003.045-.024.148-.022.296 0 .444.004.023.005.047.002.07-.024.12-.106.157-.218.155-.419-.01-.837-.001-1.255-.004-.119.01-.243-.04-.356.03-.007.016-.012.033-.014.05-.03.222 0 .257.225.257h1.348c.052 0 .104-.002.155.006.13.019.184.082.168.213-.017.133-.018.267-.01.4 0 .042-.008.083-.019.123l-.078.13c-.83-.054-1.659-.012-2.488-.025-.04-.001-.079-.003-.117.001-.154.017-.198-.016-.205-.172-.007-.143-.002-.286-.002-.428-.03-.037-.026-.082-.026-.125V5.105c0-.047-.003-.096.026-.138v-.052c-.02-.147-.023-.295 0-.442l.026-.078",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M6.486 4.967v2.03c-.065-.008-.052-.059-.052-.1V5.09c0-.048-.003-.097.052-.122",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6FAF3",
    d: "M6.486 4.473v.442c-.056-.092-.011-.194-.027-.29-.004-.029.023-.074-.033-.08-.027-.003-.076.012-.053-.037.016-.033.052-.098.113-.035",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M26.432 2.027l-.002.259c-.031 0-.05-.013-.052-.046.05-.046.027-.106.027-.159.002-.532.005-1.064-.001-1.596-.002-.106.03-.133.131-.129.195.008.39.001.584.004.04 0 .088-.02.12.024-.233 0-.467.004-.7 0-.086-.002-.111.028-.11.112.003.51.002 1.02.003 1.53",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M26.352 1.936c-.18.119-.107-.073-.168-.102.057-.046.1.103.152-.005.002-.004.038.03.04.056 0 .067 0 .134-.024.203v-.152z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M18.984 1.111c.04-.04.09-.018.135-.02-.042.023-.089.021-.135.02M5.158 3.353v-1.35h.026c0 .157-.004.315.001.472.009.277-.026.554.02.83.006.033-.018.045-.047.048M5.21 1.453h-.026c.013-.062-.066-.131-.002-.182.04-.031.056.022.047.056-.011.041-.021.082-.019.126z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M5.21 1.453c.04.038.028.083 0 .128v-.128zM10.66 5.719l-.803-.883c-.046-.05-.091-.104-.137-.155 0-.058-.043-.09-.076-.127-.087-.097-.086-.103.036-.15.022-.002.04.007.06.016.222.036.445.007.668.017.068.003.138-.01.202.025.018.01.034.024.047.04.093.077.123.217.255.257.073.073.147.147.204.234.016.061.052.103.113.123.059.062.12.124.177.188.024.026.044.054.084.028.015-.018.046-.022.046-.053l.375-.438.137-.136c.043-.012.07-.041.086-.081.009-.08.081-.108.13-.155.079-.013.157-.034.239-.022h.643c.047 0 .096.01.135-.027l.051-.002c.025.025.02.052.002.078l-.03.051v.02c-.029.049-.06.094-.126.096-.074-.01-.074-.01-.179.09.027.02.058-.016.08.007.024.087-.052.117-.093.167-.081.064-.145.143-.207.225-.017.024-.038.046-.059.067-.095.097-.196.187-.277.296-.014.013-.03.02-.05.018l-.2.197c-.043.003-.063.026-.062.069-.122.158-.122.158.03.342.054.074.093.162.187.2l.053.056c.067.112.147.21.259.282.048.04.093.083.125.138.066.104.125.215.239.279l.07.06c0 .043.018.067.061.07.098.085.189.176.26.284.011.044-.02.036-.044.036-.308-.004-.615-.003-.922 0-.078.001-.128-.042-.185-.078-.037-.017-.061-.044-.076-.08-.04-.058-.06-.131-.139-.153l-.398-.423c-.064-.052-.127-.105-.163-.182-.076-.049-.107.024-.153.056l-.085.1-.047.03c-.037.018-.067.042-.08.082l.002-.001c-.046.019-.081.047-.084.102l-.113.15c-.123.109-.208.256-.349.346-.054.04-.114.051-.181.05-.211-.003-.422 0-.633-.002-.064-.041-.11-.102-.16-.157l.24-.285c.041-.09.133-.142.183-.227.006-.01.013-.02.02-.028.056-.06.115-.116.171-.175.07-.06.127-.132.175-.21.017-.025.038-.045.063-.061.077-.045.127-.117.176-.188.015-.025.032-.049.057-.065.029-.017.055-.039.084-.056.038-.018.073-.038.077-.085.006-.05-.026-.08-.057-.112-.043-.06-.122-.091-.134-.175M15.623 4.422c.729.03 1.202.654.987 1.388-.015.049-.033.097-.05.146l-.07.087c-.03 0-.03.024-.03.045-.229.328-.562.432-.94.44-.007-.006-.01-.013-.008-.023-.327-.006-.653.001-.98-.003-.022-.001-.043-.006-.06-.023-.008-.022-.008-.042.013-.059.296-.02.592 0 .876-.007-.087-.102-.218-.078-.344-.08-.125-.002-.25.006-.376-.005-.047-.004-.1-.014-.098-.079.001-.057.045-.08.095-.089.064-.01.13-.005.194-.005.173 0 .346-.004.519.003.003 0 .009-.004.009-.006 0-.004-.003-.008-.006-.012-.161-.038-.324-.01-.486-.017-.09-.004-.18-.002-.27 0-.046.002-.088.008-.085.07-.014.076.04.162-.031.23-.039.03-.05.08-.082.115-.065.072-.134.124-.25.074v.485c.001.062.026.099.093.097.065-.002.093-.038.095-.099.004-.125 0-.25.002-.376.001-.043-.002-.088.026-.124.024-.031.043-.014.056.014 0 .304.023.607-.012.91-.04.036-.089.024-.135.025l-.68.001c-.04-.028-.022-.07-.022-.107V4.425c.02-.004.043-.014.053.017.632.01 1.265.003 1.897.004.035 0 .069-.008.1-.024",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M12.706 5.196l.045-.05c.049-.035.077-.093.134-.12.12-.05.178-.168.246-.263.055-.075.145-.122.174-.215.03-.019.058.074.088 0 .041.025.12-.065.129.077.046.826.004 1.651.02 2.477-.03.038.008.104-.052.13-.03.076.105.17-.026.234-.032-.038-.087-.052-.104-.104-.004-.035-.014-.066-.053-.078-.02-.011-.025-.03-.026-.052-.004-.084-.076-.082-.13-.104-.01-.026.043-.072-.026-.078-.022-.03-.024-.08-.078-.078-.154-.137-.317-.263-.423-.447-.034-.06-.105-.098-.158-.148-.039-.036-.064-.08-.07-.134l.012-.018c-.01-.004-.012-.002-.007.009l-.005.009c-.09-.036-.116-.15-.252-.17.123-.043.085-.108.07-.169-.043.022-.077.073-.15.038.046-.035.131-.03.107-.117-.007-.025.023-.045.051-.048.105-.01.11-.126.183-.17.008-.006-.007-.049-.012-.074l.019-.023c.128-.077.203-.203.294-.314",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#136DB6",
    d: "M13.281 4.42c-.011.072-.069.052-.111.052h-.722c-.015-.016-.015-.034 0-.05l.833-.002",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061AB",
    d: "M13.596 7.545c.08-.048.168-.024.252-.026.184-.003.368-.001.553-.001.009-.01.02-.01.03-.003.006.01.006.022-.002.032-.278.021-.555.025-.833-.002",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006FB1",
    d: "M14.479 6.477h.052c.197.03.394.005.592.014.132.006.266-.015.398.012v.025l-1.064.007-.014-.013c-.002-.026-.005-.053.036-.045",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M14.43 7.547l-.005-.027c-.024-.266-.004-.532-.011-.798-.001-.051.011-.104-.01-.153-.015-.05.009-.055.048-.042l.005.008c-.001.293-.002.586-.006.88 0 .043.024.094-.022.132",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E6CB1",
    d: "M12.448 4.421v.052c-.06-.04-.124.063-.184-.004.044-.084.118-.052.184-.048",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#437DA2",
    d: "M13.334 4.496l-.002-.078c.023-.008.056-.022.062.01.007.036-.034.05-.06.068",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F8F6",
    d: "M13.49 7.232c.032-.037.01-.096.051-.13-.01.046.032.113-.051.13",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006DA6",
    d: "M12.134 4.623c.001.059-.03.084-.086.082.022-.034.045-.067.086-.082",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0070B3",
    d: "M16.46 6.088c-.02-.012-.03-.028-.015-.049.015-.02.032-.018.045.004l-.03.045",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M25.776 6.733c-.005.006-.01.008-.018.007l-.084-.029c-.002-.06-.018-.129.078-.13.05-.002.042.023.027.053-.022.032-.027.065-.003.1",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M26.692 6.692v-.3c.031.1.034.2 0 .3",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M28.695 6.79c.04-.025.084-.03.13-.026-.04.03-.074.08-.13.025",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBDCEF",
    d: "M29.006 6.711c-.006.045-.03.074-.076.083l.05-.084.026.001",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M12.028 1.609v.625c-.045.038-.1.025-.15.025-.454.001-.908 0-1.363.002-.05 0-.105-.015-.15.023h-.053c-.016-.019-.04-.027-.06-.038-.001.014.02.022.01.038-.049.003-.08.019-.078.077.003.117.005.233 0 .349-.004.066.037.077.082.092.037.038.084.008.126.018h1.503c.047 0 .095-.007.141.009l.003-.007c.03.213.033.427-.001.64-.038.029-.083.02-.125.02-.813.002-1.625.001-2.437.001-.039 0-.078.004-.115-.013-.04-.086-.022-.177-.022-.266-.003-.87-.002-1.742-.002-2.613.003-.086.06-.057.101-.059-.014-.029-.09.026-.087-.043.003-.063.052-.084.104-.097.033-.008.068-.005.102-.006h2.309c.055 0 .112-.01.166.016.05.2.024.401.014.602-.039.056-.098.045-.154.045-.536 0-1.073.002-1.61-.002-.026 0-.051-.003-.072.018-.055.151-.015.308-.024.462-.002.048.045.043.075.056.044.026.093.013.14.013l1.487.001c.046 0 .095-.011.14.012",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0063AE",
    d: "M9.35 3.456h2.68c.026-.005.039.002.03.03-.035.04-.081.02-.122.02-.832.002-1.664.003-2.496 0-.04 0-.111.044-.12-.048.009-.013.019-.013.029-.002",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#096BB3",
    d: "M10.365 2.284c-.017-.104.065-.047.093-.047.523-.004 1.047-.003 1.57-.003l.002.05h-1.665",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#216EB6",
    d: "M9.532.411l-.099.022c-.03.007-.063.019-.062.054.001.057.06.007.081.047-.028.021-.08-.008-.102.034-.01.011-.02.012-.028 0-.01-.07-.01-.14 0-.209h2.58c.044 0 .087.003.13.005.003.02-.005.031-.026.033-.778.002-1.556 0-2.334.002-.046 0-.095-.013-.14.012",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0070B8",
    d: "M9.322.567h.028l-.001 2.609c0 .093.027.186.002.28l-.029.002c-.002-.242-.006-.484-.006-.726.001-.722.004-1.443.006-2.165",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061AC",
    d: "M12.036 2.829l-1.697.002c-.008-.007-.01-.013-.008-.019.003-.005.006-.008.009-.008l1.633-.005c.025 0 .054-.005.063.03",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0766B0",
    d: "M12.06 3.486l-.029-.03.008-.634.033.002c-.001.22.025.442-.012.662",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006AB3",
    d: "M10.261 2.284l-.06-.045c.05-.003.1-.025.112.045h-.052",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005C9C",
    d: "M10.34 2.804l-.001.027c-.03 0-.059.002-.088.001-.015 0-.02-.008-.008-.02.006-.005.015-.006.023-.01l.074.002",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061AA",
    d: "M12.264 7.468c.1.063.212.051.322.05l.829-.008c.029.04.013.051-.03.051h-.995c-.069 0-.098-.044-.126-.093",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1972B5",
    d: "M12.66 6.68l-.027.022c-.087-.09-.187-.17-.254-.278-.002-.003.014-.018.022-.027l.259.282",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116CB1",
    d: "M13.024 7.096c-.006.005-.017.016-.018.015-.095-.082-.194-.162-.221-.294.098.077.155.19.239.279",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#156EAF",
    d: "M12.348 6.34c-.11-.022-.176-.085-.187-.2.076.056.13.129.187.2",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F8F6",
    d: "M13.151 7.128c.143-.017.145-.015.13.104-.045-.032-.129-.017-.13-.104",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFAED",
    d: "M13.047 6.972c.005-.056.037-.033.062-.02.049.024.036.061.016.098-.064.021-.07.015-.078-.078",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEFF5",
    d: "M11.488 6.63c.066.05.121.11.163.182l-.036.004c-.043-.061-.143-.084-.127-.186",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F8F6",
    d: "M13.307 7.284c.021-.028.043-.022.062.002.021.027.021.054-.01.076-.034-.014-.052-.04-.052-.078",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E71AF",
    d: "M12.049 7.235c.097.004.12.076.138.152l-.138-.152",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0069AD",
    d: "M13.155 7.227c-.012.017-.029.035-.047.012-.017-.022-.049-.049-.014-.082l.061.07",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006CAD",
    d: "M12.13 5.799c-.011-.068.003-.083.064-.069l-.063.069",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006CB4",
    d: "M10.21 1.065c.006-.021-.01-.07.025-.057.16.061.325.023.488.026.381.007.763.002 1.145.002.056 0 .113.006.164-.026.023-.007.032 0 .025.025-.027.034-.066.035-.105.035l-1.742-.005",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0069B3",
    d: "M12.028 1.609h-1.633c-.045 0-.096.017-.134-.026l1.707-.006c.024 0 .054-.006.06.032",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066B0",
    d: "M12.057 1.035l-.025-.025V.412c-.01-.006-.013-.012-.01-.017.003-.006.006-.009.01-.009V.364c.04-.01.04.024.05.047l-.007.62c0 .003-.004.008-.006.008l-.012-.004",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEDF6",
    d: "M9.714 4.42l-.052.001c-.055.014-.11.04-.165 0-.014.009-.03.028-.044 0 .112-.046.227-.038.344-.029.05.005.101 0 .152-.001.139-.049.277-.057.416 0 .12-.028.247-.045.332.059.052.063.105.122.163.18v.053c-.093-.019-.134-.1-.193-.159-.02-.04-.053-.06-.092-.074-.237-.009-.474 0-.71-.003-.052-.001-.105.006-.15-.026",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M10.365 4.39h-.416c.102-.107.33-.108.416 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1973BA",
    d: "M25.024.542c-.204-.052-.41-.016-.615-.025-.099-.005-.198-.001-.297-.001L24.046.43h.915c.087 0 .054.068.063.112",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M16.173 3.458c-.002-.416-.005-.832-.005-1.248-.001-.577.002-1.154-.003-1.73 0-.099.027-.125.124-.123.247.007.494.003.741.003v.026c-.27.028-.54.003-.744.012.195.012.457-.011.718.008.022.036.013.076.013.114 0 .895 0 1.79-.002 2.685 0 .045.042.116-.052.136-.022.005.01.004.011.005.025.015.039.034.042.062-.01.05-.052.056-.089.055-.122-.002-.25.032-.361-.052-.03-.023-.08-.032-.11-.003-.071.066-.159.056-.243.063-.015 0-.028-.004-.04-.013",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0070B9",
    d: "M17.004 3.431c-.005-.108-.106-.059-.184-.107.184.037.187-.057.186-.174-.003-.912-.002-1.825-.002-2.738.009-.01.017-.011.026 0v3.046c-.01.008-.02.01-.03.002-.006-.01-.005-.02.004-.029",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0063AC",
    d: "M17.004 3.457h.025c.006.057-.036.049-.069.05h-.716c-.033-.001-.074.006-.07-.05h.024c.269-.05.538-.014.806 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2069B3",
    d: "M17.03.411l-.026.001h-.775V.386h.8l.001.025",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M10.574 7.649c0-.038.017-.064.052-.078.035 0 .049.025.066.05.024.031.053.064.003.093-.044.025-.08.023-.08-.044 0-.007-.027-.014-.041-.021M9.923 7.623h.026c.005.021.031.042.008.066-.012.013-.03.013-.043 0-.023-.024.004-.045.009-.066",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M10.66 5.719c.058.045.109.096.148.158.013.014.016.031.01.05-.036.032-.056.065-.005.103.003.012.001.023-.004.034-.04.029-.092.044-.107.1l-.044.055c-.073.058-.123.138-.19.202l-.052.055c-.075.065-.128.15-.2.215-.044.068-.14.09-.157.18-.063.046-.106.114-.176.152-.033.003-.063-.006-.09-.025h-.027c-.18.079-.276.018-.272-.176.003-.095.011-.192-.036-.28-.038-.073.03-.121.036-.183.016-.11-.1-.123-.142-.192-.018-.13-.033-.26.011-.389.03-.03.064-.034.102-.022.083.072.017.171.042.238.006-.14-.016-.295-.008-.45.004-.09-.015-.154-.122-.156-.025 0-.05-.01-.072-.026-.034-.024-.05-.05-.003-.078.03-.017.058-.035.087-.054.063-.04.105-.078.105-.169 0-.132.107-.193.232-.15.064.023.14.006.197.056 0 .022.005.041.026.052.029.066.038.14.106.186.061.04-.005.071-.02.11.074.029.167-.002.226.069.109.032.19.152.158.238-.008.022-.001.04.012.038.085-.01.148.06.23.059",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFCFA",
    d: "M9.532 6.347c-.005.036.016.082-.033.101-.047.018-.028.057-.014.073.08.09.045.197.045.296 0 .178-.003.18.172.18h.065c.018.148.012.146-.138.197-.03.01-.098.04-.098.109 0 .057-.023.108-.077.137-.034.014-.059.002-.078-.026-.048-.135-.035-.274-.013-.41.027-.168-.003-.214-.175-.214H7.64c-.161 0-.181-.015-.186-.17-.002-.073.014-.147.022-.22.129-.036.262.01.39-.026.436.006.871-.014 1.306.01.093.005.142-.05.153-.141.086.015.021.082.041.122.058.016.106-.066.167-.018",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6993A8",
    d: "M10.545 7.547c-.017.026-.045.023-.07.023h-.944c-.025 0-.066.018-.069-.03-.001-.024.024-.02.04-.024.347.035.696-.004 1.043.031",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061A9",
    d: "M10.545 7.547c-.303 0-.607 0-.91-.003-.045 0-.097.019-.134-.028h.004c.07-.046.14-.047.21.001.288-.009.577.027.864-.022l-.034.052",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#226FB5",
    d: "M9.715 7.517h-.21c.006-.065.057-.095.1-.132.026.016.052.047.076.045.124-.011.055.046.034.087",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2EFF3",
    d: "M9.897 6.998c.024-.08.095-.1.162-.127-.057.09-.13.165-.215.23V7.05c.005-.03.035-.035.053-.052",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F6E7",
    d: "M9.376 7.414c.026.01.052.018.078.026-.014.035-.04.052-.078.052-.034-.025-.033-.052 0-.078",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFCFA",
    d: "M9.897 6.998l-.052.052c-.025-.01-.043-.027-.053-.052h.105z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005AA4",
    d: "M21.043 2.862l-.002-.029h1.382c.043 0 .097-.02.125.038l-1.505-.009",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M11.198 6.894c.01-.025.027-.043.053-.052.057-.028.11-.133.191.004-.099-.025-.161.048-.244.048",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEFF5",
    d: "M11.335 6.686c.092-.11.092-.11.153-.056-.062-.01-.098.048-.153.056",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#557D9F",
    d: "M15.81 3.505l.049-.047.049.026c-.025.044-.062.03-.097.02",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F74BB",
    d: "M26.299 5.071h-1.353c.038-.042.089-.025.134-.025.358-.001.716-.004 1.074.002.088.001.114-.026.093-.107l.052.053c.023.025.021.051 0 .077",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006BB3",
    d: "M26.299 5.071v-.077c.018-.04.05-.055.091-.05l-.062.13c-.01.01-.02.01-.029-.003z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#216BB4",
    d: "M15.623 4.422c-.034.04-.078.05-.127.05h-1.84c-.012 0-.024-.005-.035-.009l.005-.021c.02-.018.043-.026.07-.026l1.927.006",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M26.3 5.071l.028.002-.006.044-1.48.003c.04-.038.09-.022.136-.022l1.187-.001c.046 0 .096.017.134-.026",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M9.114 4.391H6.643c.018-.072.077-.074.133-.074h2.155c.068 0 .138.01.183.074",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F6CB3",
    d: "M10.683 4.522l.176.161.053.076c-.067.026-.126.049-.135-.064-.007-.075-.119-.087-.126-.17.01-.01.02-.01.032-.003",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C70AE",
    d: "M11.229 5.116c-.087-.009-.136-.063-.113-.123l.113.123",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C6DAE",
    d: "M11.536 5.28c.04.065-.018.046-.046.052l.046-.053z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0070B0",
    d: "M23.774 5.722l-.002.08c-.045-.042-.051-.097-.054-.154l.03-.03c.026.03.035.065.026.104",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M27.34 6.164l-.051-.077c.04 0 .071.02.085.056.006.018-.018.02-.033.021",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCE4F2",
    d: "M15.234 2.78c-.036-.016-.058-.045-.08-.077h.054l.026.077",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006DA3",
    d: "M29.791 4.535c0-.051-.01-.092-.077-.089-.037.002-.078.012-.107-.024.042-.002.083-.006.125-.005.035.001.083-.02.101.02.017.038-.02.069-.042.098",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M27.94 4.423c-.04.035-.081.03-.124.012.04-.018.081-.017.123-.012",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F7F5",
    d: "M25.779 6.634c-.001-.022-.006-.042-.027-.053-.039-.034-.05-.07 0-.104-.013.056.096.091.027.157",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M25.57 6.373V6.4h-.13v-.026h.13",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066A4",
    d: "M11.041 6.998c-.015-.069-.007-.078.084-.101l-.084.101",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006AA7",
    d: "M11.124 6.898c-.004-.056.025-.08.079-.081-.02.033-.04.066-.08.081",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M8.594 3.456h-.103c.027-.033.063-.046.104-.05v.05",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9E9",
    d: "M19.139 5.438c.043.057-.002.09-.012.127-.014-.04-.023-.08.012-.127",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M14.61 1.61c-.265.04-.53.052-.798.056-.076 0-.136-.079-.217-.028-.012.008-.027-.038-.027-.064v-.337c.001-.058.022-.063.086-.068.154-.013.317.044.463-.047.017-.01.043-.008.064-.007l.35.026c.075.032.128.083.177.15.054.072.077.133.016.205-.031.038-.005.073-.007.11-.034.036-.07.032-.108.003",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAF0",
    d: "M14.713 1.583c-.062 0-.095-.01-.04-.078.084-.104.03-.252-.107-.294-.043-.013-.031-.043-.035-.07h.078c.204.082.193.247.162.42-.02.006-.028.04-.058.022",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCEDF4",
    d: "M14.713 1.583l.057-.023-.034.063c-.019.047-.054.064-.102.06-.026.007-.045.043-.078.02.003-.04.058-.05.053-.094.036-.003.077.012.104-.026",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#106DB3",
    d: "M14.634 1.684l.102-.06c.002.07-.002.132-.1.09l-.002-.03z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M22.446 2.755h-1.218v-.027h1.218v.027z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M22.439 2.75l.172.05c-.085.004-.14.028-.172-.05M29.658 7.128c-.003.043-.034.062-.074.085-.003-.06.026-.08.074-.085zM23.774 5.722c-.018-.032-.03-.066-.026-.104.074.019.062.058.026.104M18.41 3.327l-.103-.026c.05-.05.077-.016.103.026M18.243 3.15c.01.013.023.024.028.038.004.015-.01.023-.021.013-.013-.01-.02-.025-.031-.038l.024-.012M18.381 1.74v.363c-.035-.121-.037-.242 0-.363",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M20.022 2.232c.037.01.084-.017.1.037.004.008-.007.029-.013.03-.049.006-.063-.035-.087-.067",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A71B8",
    d: "M20.598 4.525v-.026c.135-.027.16.03.16.161-.008.87-.004 1.742-.004 2.613v.165c-.085-.085-.036-.17-.053-.241-.014-.057.047-.14-.063-.168-.026-.006-.014-.054-.014-.084 0-.641.005-1.282-.007-1.923-.002-.09.088-.081.085-.148-.003-.086-.005-.173 0-.26.005-.082-.04-.095-.104-.09",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006CB4",
    d: "M20.599 7.517c-.032-.046-.028-.099-.028-.15l.001-2.707c0-.046-.017-.097.025-.135v2.788c0 .07.005.138.027.204-.009.01-.017.01-.025 0",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0060AB",
    d: "M23.278 7.518c-.018.025-.044.026-.07.026l-2.43-.005c-.007-.005-.01-.01-.006-.014.002-.004.005-.006.008-.006l2.498-.001",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E5DAB",
    d: "M23.279 6.893h-1.791c.008-.035.032-.023.047-.023.545-.001 1.09-.001 1.634 0 .038 0 .08-.013.11.023z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5FAD",
    d: "M23.219 6.316H21.49v-.012h1.733l-.005.012",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A64AF",
    d: "M23.2 5.67h-1.718c-.008-.005-.01-.01-.008-.015.004-.005.007-.007.01-.007l1.77-.006.001.001c-.003.008-.005.016-.006.025-.015.018-.031.018-.048.002",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006BB4",
    d: "M21.484 5.648l-.002.023c-.098.005-.137-.019-.112-.136.024-.115.005-.238.034-.358 0 .123.002.246 0 .37-.002.059.008.103.08.1",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#056CB5",
    d: "M23.2 5.67l.049-.002v.57h-.022v-.403c0-.057.006-.114-.026-.165",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006AB3",
    d: "M21.377 6.365c.038.138.023.277.018.417-.035-.137.007-.279-.018-.417",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005C9C",
    d: "M20.78 7.52c0 .006 0 .012-.002.019h-.198l.019-.022h.025l.156.002",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M9.297 6.872c.03.223.03.447 0 .671-.85.003-1.7.001-2.551 0-.055 0-.113.015-.164-.022-.026-.044-.017-.093-.017-.14V4.61c0-.047-.01-.096.018-.14.033-.027.073-.022.112-.022h2.452c.03 0 .06-.001.09.011.091.173.047.352.022.53-.005.031-.014.03-.092.022.018.036.079.011.074.048-.006.045-.053.038-.085.038-.546.002-1.093.002-1.639 0-.033 0-.07.005-.097-.053.26-.06.516 0 .77-.008.255-.01.51-.003.766-.003-.463 0-.926.005-1.389-.014-.108-.005-.178.02-.17.145.001.126.005.252-.002.377-.005.088.025.108.11.107.521-.005 1.042-.003 1.563-.003.174 0 .182.004.176.173-.007.162.034.328-.03.487-.554.009-1.108.001-1.662.004-.048 0-.096-.005-.142.005-.054.083-.017.174-.025.262-.006.06 0 .121 0 .182.011-.147-.026-.297.022-.442.6-.015 1.199-.003 1.798-.007.018-.001.033.005.045.017-.037.035-.082.018-.123.018-.528.002-1.055.004-1.583 0-.095-.001-.132.021-.125.122.01.125.004.25.005.376.012.02.032.025.053.026.576.003 1.151-.002 1.726.003.08.008.076.073.079.126.007.128 0 .256.006.384 0-.01-.003-.019-.003-.029 0-.146.003-.293-.004-.439 0-.015.006-.029.016-.04",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFCFA",
    d: "M9.923 4.967c-.09-.019-.184.009-.273-.052-.047-.033-.133.1-.131.186 0 .048.09.16-.076.123-.024-.005-.068.103-.153.082.018.038.045.05.068.048.161-.017.187.065.177.205-.012.186-.003.374-.02.562-.053-.113-.026-.231-.035-.347-.041-.049-.114-.003-.156-.052-.015-.114-.06-.156-.19-.138-.17.023-.347.008-.52.008-.347 0-.694-.003-1.04.002-.097.002-.129-.026-.127-.124.009-.34-.035-.293.289-.294.486-.002.971 0 1.457 0 .172 0 .202-.043.169-.215-.027-.141-.014-.285-.007-.428.003-.065.063-.12.107-.045.08.133.237.185.304.323-.017.03-.012.05.027.052.042.035.101.05.13.104",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1670B8",
    d: "M7.371 5.15c.011-.127.035-.157.16-.155.22.003.44.02.66.023.298.005.596.001.895.026H7.45v.02h1.77c-.026-.03-.102-.022-.072-.093.023-.02.057.143.081-.007.028-.164.007-.328.017-.491.01-.023.034-.031.051-.046.04.217.013.437.013.655 0 .074-.073.043-.113.043-.59.002-1.179.002-1.768.002-.014.007-.026.019-.042.022h-.016",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006BB5",
    d: "M6.59 4.473v3.044c.009.023.002.033-.024.028-.041-.034-.022-.08-.022-.121-.001-.958-.001-1.916.001-2.874 0-.04-.042-.11.046-.124.015.016.014.031 0 .047",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0060AB",
    d: "M6.566 7.545l.025-.028 2.645-.009c.032 0 .047.013.061.035-.03.024-.066.018-.1.018l-2.57-.001c-.02 0-.04-.01-.06-.015",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#216BB4",
    d: "M6.59 4.473v-.047c.03-.004.06-.01.09-.01l2.516-.001c.033 0 .067.008.101.012-.002.032-.02.046-.051.046H6.59",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#186AB3",
    d: "M9.219 6.294l.001-.518c.001-.063-.005-.108-.088-.107-.567.01-1.135-.013-1.702.01-.028.002-.051.021-.08.014.04-.181.013-.363.021-.543.052-.002.038.038.038.064.002.1.008.2-.001.3-.01.102.032.12.125.12.525-.005 1.05-.003 1.575-.002.047 0 .096-.01.141.01.029.228.026.456.001.683l-.01-.01c-.01-.004-.017-.01-.021-.021",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72B9",
    d: "M9.25 5.642c-.579.001-1.157 0-1.736.004-.088.001-.119-.024-.12-.116-.002-.126.032-.257-.023-.38.013-.024.035-.026.058-.023-.003.125 0 .25-.01.375-.007.099.028.124.124.123.523-.004 1.046-.002 1.57-.001.045 0 .095-.017.137.018",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#036CB5",
    d: "M7.398 6.868l.026-.027c.577 0 1.153.001 1.73.004.048 0 .103-.023.143.027l-.007.019c-.039.003-.076-.017-.116-.01L7.538 6.88c-.046 0-.095.011-.14-.012",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFCFA",
    d: "M10.261 5.384c-.095-.039-.2-.013-.301-.039.017-.059.074-.065.103-.112-.127-.024-.111-.123-.114-.214.097.128.233.222.312.365",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F8F4",
    d: "M9.532 6.347c-.016.004-.034.006-.05.012-.148.065-.147.065-.137-.086 0-.01-.014-.02-.021-.03V6.19c.017-.014.034-.016.052 0 .112-.008.149.059.156.156",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFCFA",
    d: "M9.376 6.19h-.052c-.042-.147-.042-.294 0-.442.02.001.04.006.052.026v.417z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#076FB6",
    d: "M9.497 4.42l.165.001c-.019.025-.08.034-.024.085.04.036.07.083.104.124.028.033.008.044-.022.05-.078-.083-.173-.152-.223-.26",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F8F4",
    d: "M7.866 6.374c-.127.055-.26.01-.39.025.126-.057.26-.011.39-.025M9.376 5.774c-.022 0-.041-.005-.052-.026v-.026c.052.018.13-.042.156.052h-.104",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M9.793 4.863c-.028.035-.065.037-.081 0s.035-.035.054-.052c.01.017.018.035.027.052",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#076FB6",
    d: "M9.714 4.42c.269 0 .537-.002.805-.005.041 0 .077.006.106.036.015.016.016.032 0 .048-.072-.043-.152-.025-.229-.026-.182-.002-.364 0-.547 0-.05 0-.106.009-.135-.052",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF6F2",
    d: "M13.305 4.548c-.012.05-.022.09-.073.132-.07.056-.096.164-.163.225-.054.05-.072.156-.178.14-.012-.065.063-.082.076-.134l.118-.15c-.006-.066.015-.11.092-.105.059-.017.075-.085.128-.108",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B71B6",
    d: "M13.177 4.656l-.092.106c-.052-.013-.079.103-.126.04-.052-.07.04-.086.075-.122l.065-.064c.059-.054.07-.01.078.04",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3EFF6",
    d: "M12.706 5.196c-.078.123-.12.28-.294.314.09-.113.186-.22.294-.314",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6F1F6",
    d: "M10.469 6.42c.044-.083.088-.17.19-.2-.058.072-.098.16-.19.2",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6E9F3",
    d: "M12.967 4.911c.008.064-.058.085-.076.134-.056.022-.076.091-.14.101.066-.084.126-.172.216-.235",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2EFF3",
    d: "M10.06 6.872c-.024-.037-.036-.08.016-.092.061-.014.08-.076.132-.096.009-.01.017-.01.025.001-.049.07-.106.134-.174.187",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6F1F6",
    d: "M10.233 6.685h-.025c.06-.079.112-.166.208-.209-.042.086-.112.148-.183.21",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6EAF3",
    d: "M10.808 5.93v-.053c.044.03.09.058.075.123-.008.03-.025.052-.051.066-.013.003-.022 0-.03-.011l.003-.021c-.025-.035-.007-.07.003-.104",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6EAF3",
    d: "M10.702 6.164c-.042-.107.053-.086.1-.11l.008.008c.012.03-.014.037-.03.05-.027.016-.028.07-.078.052",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A70AA",
    d: "M10.78 6.112l.03-.05.073-.062c0 .07-.037.104-.103.112",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C70AE",
    d: "M10.625 4.5v-.05c.036.012.05.04.058.072l-.032.003-.026-.026",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2070B8",
    d: "M14.479 6.425v-.234c.018-.05.053-.077.107-.077.24-.001.48-.003.72.001.022 0 .041.01.058.024l.12.008c-.022.063-.067.042-.1.043-.22.002-.441 0-.662 0-.026 0-.052 0-.078.002-.042 0-.083.014-.08.064.004.049.05.038.082.038l.56.001c.056 0 .12-.02.14.072.013.06.087.012.137.058-.344.034-.674.048-1.004 0M14.452 6.527c-.02.003-.04.007-.051.028.007.006.01.012.007.018-.003.006-.005.008-.008.008-.058.173-.014.35-.023.526-.004.084-.026.123-.119.128-.114.007-.153-.028-.146-.145.01-.177.002-.354.002-.55.067.05.125.102.196.04.043-.037.096-.061.086-.143-.006-.053.055 0 .083-.012v.052c-.02.01-.026.03-.027.05",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6EBF1",
    d: "M14.456 5.823c-.002-.203-.001-.405-.007-.607-.002-.078.032-.093.1-.092.29.001.578-.002.867-.004.044-.034.084.007.126.007.032.02.08.019.088.068-.006.013-.016.022-.03.026-.066.017-.125-.013-.186-.026-.252-.013-.504-.007-.755-.004-.133.001-.146.02-.143.156.002.087.004.174.002.26-.003.102.038.155.144.153.26-.003.52.01.78-.008.048-.003.096-.016.135.026-.018.061-.074.055-.117.06-.312.03-.624.006-.936.016-.027.001-.05-.009-.068-.031",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006BB5",
    d: "M13.615 4.563V7.41h-.012V4.552l.012.011",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E6EB6",
    d: "M14.456 5.823h.898c.078 0 .156.003.224-.046.004-.011.011-.02.02-.028.03-.02.059-.04.097-.03.038.119-.059.123-.126.131-.279.036-.56.028-.841.03-.069 0-.139-.013-.206.015-.044.019-.075-.002-.095-.042.004-.012.012-.02.023-.024l.006-.006z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0475BB",
    d: "M15.364 6.139c-.235 0-.471.002-.707-.001-.066-.001-.127.007-.178.053-.039-.063 0-.097.052-.098.273-.005.546-.005.82-.004.034 0 .016.03.013.05",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006BB5",
    d: "M15.547 5.147l-.131-.027c-.05-.042-.109-.021-.163-.022-.255-.002-.51 0-.767-.027.054 0 .108-.002.162 0 .294.014.59-.03.881.028.016.003.03.016.044.024-.006.012-.014.02-.026.024",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2070B8",
    d: "M15.52 6.503h-.855c-.045 0-.096.016-.134-.026h1.082c-.028.038-.064.022-.092.026",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006DB6",
    d: "M14.4 6.581v-.026c.037.03.026.071.026.109l-.001.856-.025-.002V6.58z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006BB4",
    d: "M14.45 5.829l-.023.024c-.011-.006-.032-.011-.032-.017l-.001-.654h.032l.001.498c0 .05-.016.104.023.149",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#106EB4",
    d: "M15.547 5.147l.026-.024c.178.037.224.09.184.209-.06-.03-.093-.084-.128-.136l-.082-.05",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDEDF3",
    d: "M15.695 5.719l-.098.051c-.026-.038 0-.066.023-.089.078-.077.104-.173.115-.277.005-.011.014-.02.026-.026.052.128.003.236-.066.34",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6EBF1",
    d: "M15.63 5.196c.07.018.087.088.126.136l.005.046-.01.009c-.053-.003-.075-.05-.11-.078-.02-.032-.032-.065-.02-.103l.009-.01",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F7F8",
    d: "M12.396 6.243c-.02-.04-.012-.071.032-.102.022.051-.006.076-.032.102zM12.214 5.904c.011-.021.023-.046.052-.042.02.003.022.022.012.037-.018.03-.042.013-.064.006z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2168B2",
    d: "M12.032.386v.026h-2.5c.039-.043.09-.025.135-.025h2.365",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006FB7",
    d: "M10.157 2.771c-.063-.064-.054-.117-.04-.173.019-.075.033-.152-.015-.224-.012-.019-.021-.039 0-.056.01-.007.026-.012.036-.01.029.009.018.036.018.055v.408",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006DB6",
    d: "M10.15 1.12v.413h-.025v-.412c.008 0 .016 0 .024-.002",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A73BA",
    d: "M17.004 3.457h-.806c.081-.05.196 0 .266-.1.014-.018.117-.033.154.042.025.05.076.03.116.031.09.003.18.001.27.001v.026",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCF9E9",
    d: "M10.808 5.93c.046.036-.007.07-.003.104-.022-.023-.085.006-.074-.06.008-.049.045-.042.077-.044",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF6F5",
    d: "M13.619 1.26c.098.138.098.138.019.24-.025-.074-.029-.14-.019-.24",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#135FAC",
    d: "M9.219 6.294l.021.02-1.843.007c.038-.044.09-.025.135-.025.562-.002 1.124-.002 1.687-.002",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1360AC",
    d: "M7.398 6.868l1.82.002c.01.005.013.01.01.015-.003.005-.006.008-.009.008H7.532c-.045 0-.096.017-.134-.025",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006BB3",
    d: "M9.22 6.893l-.003-.023.073.021v.52h-.018c0-.115.003-.23-.002-.345-.002-.06.018-.13-.05-.173",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#036CB5",
    d: "M7.397 6.32v.462c-.014-.154-.056-.309 0-.461z",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFC",
    d: "M15.65 5.306c.06-.004.071.05.101.08.046.168-.08.266-.154.384-.005.006-.011.008-.02.006-.31.042-.621.014-.932.024-.118.004-.18-.03-.168-.162.01-.125.004-.252.001-.377-.001-.065.029-.106.088-.106.285-.002.571.002.857.005.006 0 .013.01.02.015.047.078.167.042.208.13",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAEF",
    d: "M15.65 5.306c-.065-.015-.12-.06-.194-.058-.048 0-.046-.04-.014-.073l.179.031c.024.03.033.063.03.1",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAE8",
    d: "M14.52 5.222c.015.04.019.076-.003.115-.016-.04-.02-.075.003-.115",
    transform: "translate(3 7)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentAmex);
export default __webpack_public_path__ + "static/media/payment-amex.3d12b1fe7eca983e52846136656eb0a6.svg";
export { ForwardRef as ReactComponent };